export default {
	ACRONYM: 'Acronym',
	ACRONYMS: 'Acronyms',
	ACRONYM_WORD: 'Word',
	ACTIONS: 'Actions',
	ACTIVE: 'Active',
	INACTIVE: 'Inactive',
	ACTIVITY_BAR: 'Activity bar',
	ACTIVITY_BAR_AI_AGENTS: 'AI Agents',
	ACTIVITY_BAR_BRANCHES: 'Branches',
	ACTIVITY_BAR_DEPLOYMENT_DASHBOARD: 'Deployment Dashboard',
	ACTIVITY_BAR_DEPLOYMENT_PACKAGES: 'Deployment Packages',
	ACTIVITY_BAR_EXPLORER: 'Explorer',
	ACTIVITY_BAR_MERGE_REQUESTS: 'Merge Requests',
	ACTIVITY_BAR_RELEASES: 'Releases',
	ACTIVITY_BAR_REPORTS: 'Reports',
	ACTIVITY_BAR_SYSTEM_SETTINGS: 'System settings',
	BRANCHES_ADMIN: 'Project Admin',
	BRANCHES_CHANGED_ELEMENTS: 'Changed elements',
	BRANCHES_CREATE: 'Create branch',
	BRANCHES_CREATED_AT: 'Created',
	BRANCHES_CREATED_BY: 'Created by',
	BRANCHES_CURRENT: 'Current branch',
	BRANCHES_INCOMING_CHANGES: 'New changes are available from {0}',
	BRANCHES_INFO: 'Branch info',
	BRANCHES_NO_PERMISSIONS: 'No permissions',
	BRANCHES_RELEASES: 'Releases',
	BRANCHES_ROOT_SOURCE: 'Root branch',
	BRANCHES_SEARCH_PLACEHOLDER: 'Search branches...',
	BRANCHES_SELECT_HINT: 'Select a branch to see its details.',
	BRANCHES_SET_ACTIVE: 'Set as active',
	BRANCHES_SOURCE: 'Source',
	BRANCHES_STATUS: 'Status',
	BRANCHES_TREE: 'Branch tree',
	MERGE_REQUESTS_APPROVALS: 'Approvals',
	MERGE_REQUESTS_AUTHOR: 'Author',
	MERGE_REQUESTS_BRANCHES_MUST_DIFFER:
		'Source and target branch must be different.',
	MERGE_REQUESTS_BRANCH_FLOW: 'Branch flow',
	MERGE_REQUESTS_CHANGES: 'Changes',
	MERGE_REQUESTS_CREATE: 'Create merge request',
	MERGE_REQUESTS_CREATED_AT: 'Created',
	MERGE_REQUESTS_FILTER: 'Filter',
	MERGE_REQUESTS_FILTER_ALL: 'All',
	MERGE_REQUESTS_LIST: 'Merge requests',
	MERGE_REQUESTS_SEARCH_PLACEHOLDER: 'Search merge requests...',
	MERGE_REQUESTS_SELECT_HINT: 'Select a merge request to see its details.',
	MERGE_REQUESTS_SOURCE_BRANCH: 'Source branch',
	MERGE_REQUESTS_STRUCTURES: 'Structures',
	MERGE_REQUESTS_TARGET_BRANCH: 'Target branch',
	MERGE_REQUESTS_TIMELINE: 'Timeline',
	MERGE_REQUESTS_TITLE: 'Title',
	MERGE_REQUESTS_DESCRIPTION: 'Description',
	MERGE_REQUESTS_SCOPE: 'Scope',
	MERGE_REQUESTS_SCOPE_FULL: 'Full change set',
	MERGE_REQUESTS_SCOPE_PARTIAL: 'Selected structures',
	MERGE_REQUESTS_QUORUM: 'Quorum',
	MERGE_REQUESTS_STATUS: 'Status',
	MERGE_REQUESTS_STATUS_OPEN: 'Open',
	MERGE_REQUESTS_STATUS_CHANGES_REQUESTED: 'Changes requested',
	MERGE_REQUESTS_STATUS_APPROVED: 'Approved',
	MERGE_REQUESTS_STATUS_MERGED: 'Merged',
	MERGE_REQUESTS_STATUS_REJECTED: 'Rejected',
	MERGE_REQUESTS_STATUS_CLOSED: 'Closed',
	MERGE_REQUESTS_STATUS_STALE: 'Stale',
	MERGE_REQUESTS_DECISION_CHANGES_REQUESTED: 'Requested changes',
	MERGE_REQUESTS_TYPE_TABLE: 'Table',
	MERGE_REQUESTS_TYPE_DIAGRAM: 'Diagram',
	MERGE_REQUESTS_TYPE_MAPPING: 'Mapping',
	MERGE_REQUESTS_TYPE_API: 'API',
	MERGE_REQUESTS_ADDED: 'Added',
	MERGE_REQUESTS_REMOVED: 'Removed',
	MERGE_REQUESTS_MODIFIED: 'Modified',
	MERGE_REQUESTS_CONFLICTS: 'Conflicts',
	MERGE_REQUESTS_NO_CHANGES: 'no changes',
	MERGE_REQUESTS_QUORUM_REACHED: 'Quorum reached',
	MERGE_REQUESTS_APPROVALS_NEEDED: 'Approvals needed',
	MERGE_REQUESTS_AUTHOR_VOTES_EXCLUDED:
		'Author votes do not count toward quorum.',
	MERGE_REQUESTS_COMMENT_OPTIONAL: 'Comment (optional)',
	MERGE_REQUESTS_REJECTION_REASON: 'Rejection reason',
	MERGE_REQUESTS_CHANGES_PROMPT: 'What needs changing?',
	MERGE_REQUESTS_COL_MR: 'Merge request',
	MERGE_REQUESTS_COL_BRANCHES: 'Branches',
	MERGE_REQUESTS_EVENT_TARGET_MOVED_RECALC:
		'Target branch moved — diff recalculated, quorum required again',
	MERGE_REQUESTS_EVENT_MERGED_AUTO: 'Merged automatically',
	MERGE_REQUESTS_EVENT_MERGE_COMPLETED: 'Merge completed',
	MERGE_REQUESTS_EVENT_MR_CLOSED: 'Merge request closed',
	MERGE_REQUESTS_EVENT_TARGET_MOVED_QUORUM:
		'Target branch moved — quorum required again',
	MERGE_REQUESTS_EVENT_TARGET_CHANGED:
		'Target branch changed — diff was recalculated; quorum must be obtained again.',
	MERGE_REQUESTS_EVENT_MERGED_AFTER_QUORUM:
		'Merged automatically after quorum was reached.',
	MERGE_REQUESTS_EVENT_MERGED_INTO_TARGET:
		'Merge request was merged into the target branch.',
	MERGE_REQUESTS_EVENT_QUORUM_COMPLETE_MERGE:
		'Quorum reached — complete the merge with the Merge button.',
	MERGE_REQUESTS_DIFF_NO_TABLE_ATTR:
		'No table-level attribute changes.',
	MERGE_REQUESTS_DIFF_SOURCE: 'Source',
	MERGE_REQUESTS_DIFF_TARGET: 'Target',
	MERGE_REQUESTS_DIFF_NO_COLLECTION_CHANGES:
		'No changes in this collection.',
	MERGE_REQUESTS_DIFF_CUSTOM_VALUE: 'Custom value',
	MERGE_REQUESTS_DIFF_CUSTOM_VALUE_FOR: 'Custom value for "{0}"',
	MERGE_REQUESTS_DIFF_CUSTOM: 'Custom',
	MERGE_REQUESTS_DIFF_CUSTOM_SET: 'Custom ✓',
	MERGE_REQUESTS_DIFF_UNRESOLVED_CONFLICT: 'Unresolved conflict',
	MERGE_REQUESTS_DIFF_RESOLVE: 'Resolve',
	MERGE_REQUESTS_DIFF_SUBTITLE: 'Diff · attributes + sub-records',
	MERGE_REQUESTS_DIFF_ALL_RESOLVED: 'All resolved',
	MERGE_REQUESTS_DIFF_BULK: 'Bulk:',
	MERGE_REQUESTS_DIFF_ACCEPT_ALL_SOURCE: 'Accept all source',
	MERGE_REQUESTS_DIFF_ACCEPT_ALL_TARGET: 'Accept all target',
	MERGE_REQUESTS_DIFF_RESET: 'Reset',
	MERGE_REQUESTS_DIFF_BASIC_ATTRS: 'Basic attributes',
	MERGE_REQUESTS_DIFF_CHANGED_COUNT: '{0} changed',
	MERGE_REQUESTS_DIFF_SOURCE_LABEL: 'Source · {0}',
	MERGE_REQUESTS_DIFF_TARGET_LABEL: 'Target · {0}',
	MERGE_REQUESTS_DIFF_NO_CHANGES: 'No changes between branches.',
	MERGE_REQUESTS_DIFF_DONE: 'Done',
	MERGE_REQUESTS_PAGE_TITLE: 'Merge Requests',
	MERGE_REQUESTS_PAGE_SUBTITLE:
		'Formal branch merges with approvals and conflict resolution',
	MERGE_REQUESTS_CREATE_MR: 'Create MR',
	MERGE_REQUESTS_MR_CLOSED: 'Merge request is closed.',
	MERGE_REQUESTS_MERGE: 'Merge',
	MERGE_REQUESTS_APPROVE: 'Approve',
	MERGE_REQUESTS_RESOLVE_CONFLICTS_FIRST: 'Resolve {0} conflicts first',
	MERGE_REQUESTS_CANNOT_SELF_APPROVE:
		'This is your merge request — you cannot approve it yourself.',
	MERGE_REQUESTS_REQUEST_CHANGES: 'Request changes',
	MERGE_REQUESTS_REJECT: 'Reject',
	MERGE_REQUESTS_CLOSE_MR: 'Close MR',
	MERGE_REQUESTS_NO_DECISIONS: 'No decisions yet.',
	MERGE_REQUESTS_SIMULATE_TARGET_MOVED: 'Simulate: target branch moved',
	MERGE_REQUESTS_DEPENDENCY: 'Dependency',
	MERGE_REQUESTS_DEPENDENCY_MISSING:
		'Dependency "{0}" is not in the selection',
	MERGE_REQUESTS_EMPTY_FILTER: 'No merge requests for this filter.',
	MERGE_REQUESTS_UNRESOLVED_CONFLICTS: '{0} unresolved conflicts',
	MERGE_REQUESTS_UNRESOLVED_COUNT: '{0} unresolved',
	MERGE_REQUESTS_RESOLVED: 'resolved',
	MERGE_REQUESTS_DIFF: 'Diff',
	MERGE_REQUESTS_HISTORY: 'History',
	MERGE_REQUESTS_BACK_TO_LIST: 'Back to list',
	MERGE_REQUESTS_AFFECTED_STRUCTURES: 'Affected structures',
	MERGE_REQUESTS_STRUCTURES_SUMMARY: '{0} · {1} conflicts',
	MERGE_REQUESTS_CHERRY_PICK: ' · cherry-pick',
	MERGE_REQUESTS_EVENT_APPROVED_BY: 'Approved by {0}',
	MERGE_REQUESTS_EVENT_REQUESTED_CHANGES: '{0} requested changes',
	MERGE_REQUESTS_EVENT_REJECTED_BY: '{0} rejected',
	MERGE_REQUESTS_EVENT_CREATED: 'Merge request created',
	MERGE_REQUESTS_EVENT_CREATED_PARTIAL: 'Merge request created (cherry-pick)',
	ADD: 'Add',
	ALLOW_WRITE_API: 'Allow write API',
	ALPHABETICAL_ORDER: 'Alphabetical order',
	ADD_ELEMENT: 'Drop element to add',
	ADD_ELEMENTS_TO_DEPLOYMENT_PKG: 'Add elements to deployment package',
	ADD_ELEMENT_TO_DEPLOYMENT_PKG: 'Add element to deployment package',
	ADD_ENVIRONMENT: 'Add environment',
	ADD_ENVIRONMENTS: 'Add environments',
	ADD_FOLDER: 'Add folder',
	ADD_NEW: 'Add new',
	ADD_NEW_ACRONYM: 'Add new acronym',
	ADD_NEW_API_COLLECTION: 'Add new rowset',
	ADD_NEW_API_NODE: 'Add new api node',
	ADD_NEW_DIAGRAM: 'Add new diagram',
	ADD_NEW_CHAT: 'Add new chat',
	ADD_NEW_FOLDER: 'Add new folder',
	ADD_NEW_MAPPING: 'Add new mapping',
	ADD_NEW_MAPPING_READ: 'Add new read mapping',
	ADD_NEW_MAPPING_WRITE: 'Add new write mapping',
	ADD_NEW_QUEUE: 'Add new queue',
	ADD_NEW_RELEASE: 'Add new deployment package',
	ADD_NEW_SYSTEM: 'Add new system',
	ADD_NEW_TABLE: 'Add new table',
	ADD_NEW_VIEW: 'Add new view',
	ADD_NEW_WORKFLOW: 'Add new workflow',
	ADD_DIAGRAM: 'Add diagram',
	ADD_OBJECT_SETTINGS: 'Add object',
	ADD_STEREOTYPE: 'Add stereotype',
	ADD_SYSTEM: 'Add system',
	ADD_TABLE: 'Add table',
	ADD_WORKFLOW: 'Add workflow',
	AI_AUTH_FAILURE: 'Authentication validation failed',
	AI_CONFIGURATION: 'AI assistant',
	AI_CONFIGURATION_CLEAR: 'CLEAR',
	AI_CONFIGURATION_SAVE_SUCCESS: 'AI configuration saved successfully!',
	AI_CONFIGURATION_SAVE_FAILURE:
		'Failed to save AI configuration. Please try again.',
	AI_CONNECTION_STATUS_RECONNECTING: 'Reconnecting...',
	AI_CONNECTION_STATUS_CONNECTED: 'Connected',
	AI_CONNECTION_STATUS_CONNECTED_2: 'Connected to AI Assistant',
	AI_CONNECTION_STATUS_CONNECTING: 'Connecting...',
	AI_CONNECTION_FAILURE: 'Connection failed:',
	AI_COMMAND_DELETE_WARNING:
		'AI requested delete, but backend does not support it yet.',
	AI_COMMAND_LOCK_WARNING: 'Node not found for lock: {triggerNodeId}',
	AI_COMMAND_REFRESH_WARNING:
		'Missing structure context for update/create: {triggerNodeId}',
	AI_COMMAND_UNLOCK_WARNING: 'Node not found for unlock: {triggerNodeId}',
	AI_COMMAND_ERROR: 'Failed to process AI command messages: {error}',
	AI_INITIALS: 'AI',
	AI_NEW_CHAT: 'New chat started',
	AI_THINKING: 'Thinking ...',
	AI_STOP: 'Stop response',
	AI_UNSAVED_WARNING:
		'AI has updated this {structureType} with this nodeId:{nodeId}, but you have unsaved changes.',
	ALLOWED_IGNORE: 'Allowed ignore',
	API_COLLECTION: 'Api collection',
	API_MAPPINGS: 'API Mappings',
	API_NODE: 'Api node',
	API_NODE_COLUMNS_TYPE: 'Type',
	API_NODE_COLUMN_TYPE_IN: 'In',
	API_NODE_COLUMN_TYPE_INTERNAL: 'Internal',
	API_NODE_COLUMN_TYPE_IN_OUT: 'In/Out',
	API_NODE_COLUMN_TYPE_OUT: 'Out',
	APPLICATION_NAME: 'MDD',
	APPLICATION_LOGO_ALT: 'MetaCroc',
	AUTOCOMPLETE_ELEMENTS: 'Autocomplete elements (table names & columns)',
	AUTOCOMPLETE_KEYWORDS: 'Autocomplete keywords',
	AUTOCOMPLETE_SNIPPETS: 'Autocomplete snippets',
	AUTOSAVE_DIRTY: 'Autosaving changes…',
	AUTOSAVE_SAVED: 'Working data saved',
	/** MDD-2599: Unified edit status in header */
	EDIT_STATUS_NO_CHANGES: 'Edit - no changes',
	EDIT_STATUS_CHANGES_SAVED: 'Edit - changes - saved',
	EDIT_STATUS_SAVING_IN: 'Edit - changes - saving in {0} s',
	EDIT_STATUS_UNSAVED: 'Edit - changes (unsaved)',
	UNSAVED_CHANGES_SAVE_PROMPT: 'Save changes before closing?',
	UNSAVED_CHANGES_TITLE: 'Unsaved changes',
	BACK: 'Back',
	BASIC: 'Basic',
	BATCH_DELETE: 'Batch delete',
	BATCH_EDIT: 'Batch edit',
	BATCH_EXPORT: 'Generate script',
	BATCH_UNLOCK: 'Batch unlock',
	BATCH_UNLOCK_HEADER: 'Unlock selected elements',
	BATCH_UNLOCK_MESSAGE: 'Are you sure you want to unlock {0} element(s)?',
	BATCH_UNLOCK_FORCE_MESSAGE:
		'Are you sure you want to unlock {0} element(s)? {1} element(s) are locked by other users.',
	BATCH_UNLOCK_OWN_MESSAGE:
		'You can only unlock {0} element(s) that you have locked.',
	BATCH_UNLOCK_NO_PERMISSION:
		'You do not have permission to unlock elements locked by other users.',
	NO_LOCKED_ELEMENTS_SELECTED: 'No locked elements selected.',
	NO_CONFIRMATION_STATE: 'No confirmation state available',
	NO_ELEMENTS_TO_EDIT:
		'All selected elements are locked by other users. No elements available to edit.',
	BUSINESS_COLUMNS_TITLE: 'Business columns',
	BUSINESS_DOMAINS: 'Business domains',
	BUSINESS_DOMAIN: 'Business domain',
	BUSINESS_DOMAIN_DESCRIPTION: 'Description',
	BUSINESS_DOMAIN_NAME: 'Name',
	BUSINESS_METADATA: 'Business metadata',
	BUTTON_PERMISSIONS: 'Permissions',
	CANCEL: 'Cancel',
	CANCEL_AND_UNLOCK_ALL_ELEMENTS: 'Cancel and unlock all elements',
	CANCEL_EDIT_HEADER: 'Cancel edit of {0}',
	CANCEL_EDIT_MESSAGE:
		'This will erase your autosaved working version of {0}. Do you want to proceed?',
	CANCEL_SELECT_MODE: 'Cancel select mode',
	CLEAR: 'Clear',
	CATEGORY: 'Category',
	CHANGE: 'Change',
	CHANGE_PASSWORD: 'Change password',
	CHECK: 'Check',
	CHECKING: 'Checking...',
	CHECKBOX_FALSE: 'No',
	CHECKBOX_TRUE: 'Yes',
	CLICK_TO_OPEN_TABLE: 'Click to open the table',
	CLIENT_ID: 'Client ID',
	CLOSE: 'Close',
	CLOSE_ALL_TABS: 'Close all tabs',
	CLOSE_OTHER_TABS: 'Close other tabs',
	CLOSE_TAB: 'Close tab',
	CLOSE_HISTORY: 'Close history',
	CODE: 'Code',
	CODE_REQUIRED: 'Code is required',
	CODE_PREVIEW: 'code preview',
	COLUMN: 'Column',
	COLUMNS: 'Columns',
	COLUMN_WITH_SAME_CODE_ALREADY_EXISTS: 'Column with same code already exists',
	COLUMN_WITH_SAME_NAME_ALREADY_EXISTS: 'Column with same name already exists',
	COMMENT: 'Comment',
	COMPANY: 'Company',
	COMPLETE: 'Complete',
	CONFIRM: 'Confirm',
	CONFIRM_CLOSE_MESSAGE:
		'Closing this modal will discard your changes, do you want to continue?',
	NEW_CHAT_CONFIRM_TITLE: 'Clear Messages?',
	NEW_CHAT_CONFIRM_MESSAGE:
		'This will clear your current chat history. Are you sure you want to continue?',
	RECENT_CHATS: 'Recent Chats',
	LOADING_RECENT_CHATS: 'Loading recent chats…',
	FAILED_TO_LOAD_RECENT_CHATS: 'Failed to load recent chats',
	RECENT: 'Recent',
	CONFIRM_GENERATE_SECRET: 'Generate secret confirm',
	GENERATE_SECRET_CONFIRMATION_MESSAGE:
		'You are about to generate a new secret. This will invalidate all existing tokens. Do you want to continue?',
	GENERATED_SECRET: 'Generated secret',
	GENERATE_LATEST_VERSION: 'Latest version',
	GENERATE_LATEST_TEMPLATE: 'Latest template',
	GENERATION_DATE_TIME_OPTIONS: 'GENERATION DATE/TIME OPTIONS',
	CONFIRM_DELETE: 'Confirm delete',
	CONFIRM_DELETE_MESSAGE:
		'You are about to delete {0}. Do you want to continue?',
	SECRET_DISPLAY_MESSAGE:
		'Here is your new secret. Please save it somewhere safe.',
	CONSTRAINT_TYPE_CHECK: 'Check',
	CONSTRAINT_TYPE_CUSTOM: 'Custom',
	CONSTRAINT_TYPE_FOREIGN_KEY: 'Foreign key',
	CONSTRAINT_TYPE_PRIMARY_KEY: 'Primary key',
	CONSTRAINT_TYPE_UNIQUE: 'Unique',
	CONSTRAINT_REFERENCE_TABLE_NOT_AVAILABLE:
		'The reference table for "{0}" is no longer available. Please select a different table from the dropdown.',
	CONSTANT_DOMAIN: 'Constant domain',
	CONTEXT_ADD_API_ROWSET: 'Add rowset',
	CONTEXT_ADD_API_NODE: 'Add api node',
	CONTEXT_ADD_FOLDER: 'Add folder',
	CONTEXT_ADD_MAPPING: 'Add mapping',
	CONTEXT_ADD_MAPPING_READ: 'Add read mapping',
	CONTEXT_ADD_MAPPING_WRITE: 'Add write mapping',
	CONTEXT_ADD_QUEUE: 'Add queue',
	CONTEXT_ADD_TABLE: 'Add table',
	CONTEXT_ADD_VIEW: 'Add view',
	CONTEXT_ADD_WORKFLOW: 'Add workflow',
	CONTEXT_DELETE: 'Delete',
	CONTEXT_LOCK: 'Lock',
	CONTEXT_OPEN_TAB: 'Open in new tab',
	CONTEXT_UNLOCK: 'Unlock',
	COPIED: 'Copied',
	COPY: 'Copy',
	COPY_CODE_TO_CLIPBOARD: 'Copy code to clipboard',
	COPY_TO_CLIPBOARD: 'Copy to clipboard',
	COPYRIGHT: '© 2021 Adastra, Member of Adastra Group',
	CREATE: 'Create',
	CREATE_ALL_DUPLICIT_TABLES_ANYWAY: 'Create all duplicit tables anyway',
	CREATE_ANYWAY: 'Create anyway',
	CREATE_BUSINESS_DOMAIN: 'Create business domain',
	CREATE_DDL: 'Create',
	CREATE_DEPENDENCY: 'Create dependency',
	CREATE_DEPLOYMENT_PACKAGE:
		'No results found, would you like to create {0} as a new DP?',
	CREATE_DOMAIN: 'Create domain',
	CREATE_OBJECT_SETTINGS: 'Create object types',
	CREATE_STEREOTYPE: 'Create stereotype',
	CREATE_SYSTEM: 'Create system',
	CREATE_TECH_COLUMN: 'Create technical column',
	CSV_CAN_BE_IMPORTED_ONLY_IN_FOLDER: 'CSV can be imported only in folder',
	CURRENT_NODE_NAME_ACRONYM: 'Current node name acronym',
	CUSTOM_ATTRIBUTE: 'Custom attribute',
	CUSTOM_ATTRIBUTES: 'Custom attributes',
	CUSTOM_ATTRIBUTE_NEW: 'Create custom attribute',
	CUSTOM_ATTRIBUTE_UPDATE: 'Update custom attribute',
	CUSTOM_LISTS_OF_VALUES: 'Custom lists of values',
	CUSTOM_LOV: 'Custom LOV',
	CUSTOM_LOV_NEW: 'Create custom LOV',
	CUSTOM_LOV_UPDATE: 'Update custom LOV',
	DATA_CATALOG_BUSINESS_DOMAIN: 'Business domain',
	DATA_CATALOG_COLUMN: 'Column',
	DATA_CATALOG_COLUMNS: '{0} columns',
	DATA_CATALOG_COLUMNS_SECTION: 'Columns',
	DATA_CATALOG_COLUMN_DESCRIPTION: 'Description',
	DATA_CATALOG_DATA_TYPE: 'Data type',
	DATA_CATALOG_DESCRIPTION:
		'Overview of data tables across systems — business descriptions, columns, data lineage and ontology links. Currently showing {0} tables.',
	DATA_CATALOG_DOMAIN_LABEL: 'Domain',
	DATA_CATALOG_LINEAGE: 'Data lineage',
	DATA_CATALOG_NOT_NULL: 'NOT NULL',
	DATA_CATALOG_NULL: 'NULL',
	DATA_CATALOG_NULLABLE: 'Null',
	DATA_CATALOG_ONTOLOGY: 'Related terms (ontology)',
	DATA_CATALOG_OPEN_IN_DEVELOPER: 'Open in Developer',
	DATA_CATALOG_READ_ONLY_BADGE: 'Read-only catalog',
	DATA_CATALOG_ROWS: 'Rows',
	DATA_CATALOG_SEARCH_PLACEHOLDER: 'Search table...',
	DATA_CATALOG_STEWARD: 'Steward',
	DATA_CATALOG_SYSTEM: 'System',
	DATA_CATALOG_SYSTEM_LABEL: 'System',
	DATA_CATALOG_TABLE_COUNT: '{0} tables',
	DATA_CATALOG_TABLES: 'Tables',
	DATA_CATALOG_TITLE: 'Data Catalog',
	DATA_CATALOG_UPDATED: 'updated {0}',
	REPORTS_CATALOG_BADGE: 'Reports catalog',
	REPORTS_CATEGORY: 'Category',
	REPORTS_CONSUMERS: 'Consumers',
	REPORTS_COUNT: '{0} reports',
	REPORTS_DESCRIPTION:
		'Catalog of reports, dashboards and exports built on the data model — source tables, refresh schedule, owner and consumers. Currently showing {0} reports.',
	REPORTS_FIELDS: 'Key fields / metrics',
	REPORTS_LAST_RUN: 'Last run',
	REPORTS_LIST: 'Reports',
	REPORTS_OPEN: 'Open report',
	REPORTS_OWNER: 'Owner',
	REPORTS_SCHEDULE: 'Refresh',
	REPORTS_SEARCH_PLACEHOLDER: 'Search report...',
	REPORTS_SOURCES: 'Source tables',
	REPORTS_SYSTEM: 'System',
	REPORTS_TITLE: 'Reports',
	REPORTS_TYPE: 'Type',
	REPORTS_USAGE: 'Usage',
	DATABASE_CONNECTION: 'Database connection',
	DATE: 'Date',
	DATE_OF_DEPLOYMENT: 'Date of deployment',
	DEPLOYMENT_DATE: 'Deployment date',
	DAYS: 'Days',
	DDL_CREATION_FAILED: 'DDL generation failed',
	DDL_SCRIPT: 'DDL script',
	DEFAULT: 'Default',
	DEFAULT_MAPPING: 'Default mapping',
	DEFAULT_MAPPING_HISTORICAL: 'Historical mapping',
	DEFAULT_MAPPING_INTERFACE: 'Interface mapping',
	DEFAULT_MAPPING_REFERENCE: 'Reference mapping',
	DELETE: 'Delete',
	USER_DELETED_SUCCESSFULLY: 'User deleted successfully',
	DELETE_CUSTOM_ATTRIBUTE: 'Delete custom attribute',
	DELETE_CUSTOM_LOV: 'Delete custom LOV',
	DELETE_FOLDER: 'Delete folder',
	DELETE_MAPPING: 'Delete mapping',
	DELETE_MAPPING_READ: 'Delete read mapping',
	DELETE_MAPPING_WRITE: 'Delete write mapping',
	DELETE_NODE_HEADER_NOT_EMPTY: 'Delete not empty node',
	DELETE_NODE_MESSAGE: 'Do you want to delete "{0}"?',
	DELETE_NODE_MESSAGE_NOT_EMPTY:
		'Entity {0} has some children. Are you really want to delete {0} and all his children?',
	DELETE_ROW: 'Delete row',
	DELETE_SELECTED_ELEMENTS: 'Delete selected elements and their children',
	DELETE_SYSTEM: 'Delete system',
	DELETE_TABLE: 'Delete table',
	DELETE_VIEW: 'Delete view',
	DELETE_WORKFLOW: 'Delete workflow',
	DONT_SAVE: "Don't save",
	DEPENDENCIES: 'Dependencies',
	DEPLOYED_BY: 'Deployed by',
	DEPLOYED_HISTORY_ID: 'Deployed History Id',
	DEPLOYED_HISTORY_ID2: 'Deployed History Id',
	DEPLOYED_PUSHED_VERSION: 'Deployed pushed version',
	DEPLOYED_UNPUSHED_CHANGES_WARN:
		'Unpushed changes will only be reflected in the preview',
	DEPLOYED_UNPUSHED_CHANGES_WARN_TITLE: 'Unpushed changes',
	DEPLOYED_VERSION: 'Deployed version',
	DEPLOYED_VERSION_INFO: 'Version {0}',
	DEPLOYMENT: 'Deployment',
	DEPLOYMENT_GIT: 'Deployment to git repository',
	DEPLOYMENT_GIT_PUSHED: 'Successfully pushed to git repository',
	DEPLOYMENT_MARK_CREATED: 'Structure was successfully marked as deployed',
	DESCRIPTION: 'Description',
	DESCRIPTION_SECTION: 'Description',
	DIAGRAM_ADD_TABLE: 'Add table',
	DIAGRAM_AUTO_LAYOUT: 'Auto layout',
	DIAGRAM_COLUMNS_CODE: 'Table columns code',
	DIAGRAM_COLUMNS_NAME: 'Table columns name',
	DIAGRAM_CHANGELOG: 'Diagram elements have changed',
	DIAGRAM_DELETE_TABLE: 'Delete table',
	DIAGRAM_GRID_CELL_SIZE: 'Grid cell size',
	DIAGRAM_GRID_HORIZONTAL_LINE: 'Grid horizontal line',
	DIAGRAM_GRID_INTERVAL_HORIZONTAL_LINE: 'Grid interval horizontal line',
	DIAGRAM_GRID_INTERVAL_VERTICAL_LINE: 'Grid interval vertical line',
	DIAGRAM_GRID_SWITCH: 'Grid',
	DIAGRAM_GRID_VERTICAL_LINE: 'Grid vertical line',
	DIAGRAM_LINK_DOESNT_EXIST_IN_PROJECT: 'Link does not exist in project',
	DIAGRAM_LINK_COLOR: 'Link color',
	DIAGRAM_LINK_PROPERTIES: 'Constraint properties',
	DIAGRAM_LINK_PROPERTIES_TEXT: 'Please select a link to view properties',
	DIAGRAM_MANUAL_LAYOUT: 'Manual layout',
	DIAGRAM_NODE_BODY_COLOR: 'Node body color',
	DIAGRAM_NODE_COLUMNS_BACKGROUND: 'Table columns background',
	DIAGRAM_NODES_COMMENTS: 'Show comments',
	DIAGRAM_NODE_CONSTRAINT_COLOR: 'Constraint color',
	DIAGRAM_NODE_DELETED: 'Deleted node',
	DIAGRAM_NODES_DESCRIPTION: 'Show desriptions',
	DIAGRAM_NODE_ID: 'ID:',
	DIAGRAM_NODE_FROM: 'From node:',
	DIAGRAM_NODE_FULL_PATH: 'Full path:',
	DIAGRAM_NODE_HEADER_COLOR: 'Table header color',
	DIAGRAM_NODE_NAME: 'Name:',
	DIAGRAM_NODE_NAME_BACKGROUND: 'Node name background',
	DIAGRAM_NODE_PROPERTIES: 'Table properties',
	DIAGRAM_NODE_PROPERTIES_TEXT: 'Please select a table to view properties',
	DIAGRAM_NODE_TEXT: 'Text:',
	DIAGRAM_NODE_TO: 'To node:',
	DIAGRAM_NODE_TYPE: 'Type:',
	DIAGRAM_PK_CODE: 'Primary key code',
	DIAGRAM_PK_NAME: 'Primary key name',
	DIAGRAM_PROPERTIES: 'Diagram properties',
	DisplayOptions: 'DISPLAY OPTIONS',
	DIAGRAM_PROPERTIES_NONE: 'None at this time.',
	DIAGRAM_REMOVE_TABLE: 'Remove table',
	DIAGRAM_ROUTING_TYPE: 'Routing type:',
	DIAGRAM_ROUTING_TYPE_DIRECT: 'Direct',
	DIAGRAM_ROUTING_TYPE_ORTHOGONAL: 'Orthogonal',
	DIAGRAM_TABLE_NAME: 'Table name',
	DIAGRAM_TABLE_SHOW_COLUMNS: 'Show columns',
	DIAGRAM_TABLE_CONSTRAINT_CODE: 'Show constraint code',
	DIAGRAM_TABLE_CODE: 'Table code',
	DIAGRAM_VALIDATION_TEXT_MISMATCH: 'Was renamed.',
	DIAGRAM_VALIDATION_LINK_NOT_EXIST: 'Link does not exist',
	DIAGRAM_VALIDATION_TABLE_NOT_EXIST: 'Table does not exist in the project',
	DIAGRAM_DELETED_NODES_WARNING:
		'The following nodes have been deleted, remove them and push the changes to finalize the deletion:',
	DIAGRAM_SYNC_SUCCESS: 'Latest changes loaded. Ready for editing.',
	DIAGRAM_SYNC_WARNING:
		"This diagram is outdated. Click 'EDIT' to load the latest changes.",
	DIAGRAM_WARNING:
		'Diagram ref is null or undefined. This occurred during the validateTablesInDiagram process. Ensure that the diagram reference is correctly set before this process. Failure to define the diagram reference may result in accuracy errors during validation.',
	DOMAINS: 'Domains',
	DOMAIN_CODE: 'Code',
	DOMAIN_COMPANY_NAME: 'Company name',
	DOMAIN_CUSTOM: 'Custom',
	DOMAIN_DATA_TYPE: 'Data type',
	DOMAIN_DEFAULT_VALUE: 'Default value',
	DOMAIN_DESCRIPTION: 'Description',
	DOMAIN_HAS_TEMPLATE: 'Has template',
	DOMAIN_MANDATORY: 'Mandatory', // only for import
	DOMAIN_NAME: 'Domain name',
	DOMAIN_NOT_FOUND: 'Domain not found',
	DOMAIN_NOT_NULL: 'Not null',
	DOMAIN_TECHNOLOGY_CODE: 'Technology code',
	DOMAIN_TEMPLATE: 'Template',
	DOMAIN_TEMPLATE_VALUE_FORMAT: 'Template value format',
	DOMAIN_TEMPLATE_VALUE_REGEX: 'Template value regex',
	DOMAIN_TEXT_VALUE_FLAG: 'Text value',
	DOMAIN_UPDATE_AFFECTED_MESSAGE:
		'This change affects {0} columns in {1} tables.',
	DOMAIN_UPDATE_CONFIRM_TITLE: 'Update columns?',
	DONE: 'Done',
	DOWNLOAD: 'Download',
	DOWNLOAD_AS_JSON: 'Download as JSON',
	DOWNLOAD_IMPACT_AS_CSV: 'Download impact as CSV',
	DOWNLOAD_VERSION_TO_COMPARE: 'Download (version to compare)',
	DOWNLOAD_ZIP: 'Download zip',
	DO_NOT_IMPORT_TECHNICAL_COLUMNS: 'Do not import technical columns',
	DRAG_AND_DROP_COLUMNS_TO_MATCH_FIELDS:
		'Drag & Drop columns to match the fields',
	DRAG_COLUMN_HERE: 'Drag column here',
	DROP_FILE: 'Drop file here',
	DROP_TABLE: 'Drop table',
	DUPLICATE: 'Duplicate',
	DUPLICATE_COLUMN_CODE: 'Duplicate column code',
	DUPLICATE_COLUMN_NAME: 'Duplicate column name',
	DUPLICIT_TABLES: 'Duplicit tables',
	EDIT: 'Edit',
	EDIT_AND_LOCK: 'Edit and lock',
	EDIT_IN_MODAL: 'Edit in modal',
	EDITOR_SAVE_HINT: 'Ctrl+S / Esc / Click outside to save',
	EDITABLE_BY_ACTUAL_USER: 'Editable by actual user',
	EDIT_API_USER: 'Edit API user',
	CREATE_API_USER: 'Create API user',
	ELEMENT: 'Element',
	ELEMENT_DETAIL_TABS: 'Element detail tabs',
	ELEMENTS: 'Elements',
	ELEMENTS_IN_RELEASE: 'Elements',
	ELEMENT_TYPE: 'Element type',
	ELEMENT_TYPES: 'Element types',
	EMAIL: 'Email',
	ENTER_SELECT_MODE: 'Enter select mode',
	ENTITY_TYPE_AGGREGATE: 'Aggregate',
	ENTITY_TYPE_AUXILIARY: 'Auxiliary',
	ENTITY_TYPE_COMPOSITION: 'Composition',
	ENTITY_TYPE_FUNDAMENTAL: 'Fundamental',
	ENTITY_TYPE_METADATA: 'Metadata',
	ENTITY_TYPE_RELATION: 'Relation',
	ENTITY_TYPE_SNAPSHOT: 'Snapshot',
	ENTITY_TYPE_SPECIALISATION: 'Specialisation',
	ENTITY_TYPE_TRANSACTION: 'Transaction',
	ENVIRONMENT: 'Environment',
	ENVIRONMENTS: 'Environments',
	ENVIRONMENTS_IN_RELEASE: 'Environments',
	ENLARGE_DIAGRAM: 'Enlarge diagram',
	ERROR: 'Error',
	ERROR_NO_CRON: 'Cron string not set',
	ERROR_NO_DAY: 'Day not set',
	ERROR_NO_OTHER_WORKFLOW: 'Other workflow not selected',
	ERROR_NO_SCRIPT: 'Script not set',
	ERROR_NO_TIME: 'Time not set',
	ERROR_NO_WEEKDAY: 'Weekday not set',
	ERROR_LOADING_GIT_BRANCHES: 'Error loading Git branches',
	ERROR_RENDERING_MERMAID_DIAGRAM: 'Error rendering Mermaid diagram:',
	FROZEN: 'Frozen',
	ERROR_WHEN_SAVING: 'Error when saving',
	EVENT_NAME: 'Event name',
	EXECUTE_MAPPING_UNSET: '<< UNDEFINED >>',
	EXECUTE_READ_MAPPING: 'Mapping',
	EXECUTE_READ_NODE: 'Execute (Read)',
	EXECUTE_READ_RUN_MAPPING: 'Read {0}',
	EXECUTE_WRITE_CALL_MAPPING: 'Call {0}',
	EXECUTE_WRITE_MAPPING: 'Mapping',
	EXECUTE_WRITE_METHOD: 'Execution method',
	EXECUTE_WRITE_METHOD_CALL_MAPPING: 'Call mapping',
	EXECUTE_WRITE_METHOD_RUN_MAPPING: 'Run mapping',
	EXECUTE_WRITE_METHOD_RUN_SCRIPT: 'Run script',
	EXECUTE_WRITE_NODE: 'Execute (Write)',
	EXECUTE_WRITE_RUN_MAPPING: 'Run {0}',
	EXECUTE_WRITE_RUN_SCRIPT: 'Run script',
	EXECUTE_WRITE_SCRIPT: 'Script',
	EXISTING: 'Existing',
	EXPECTED_FORMAT: 'Expected format',
	EXPLICIT_RIGHTS: 'Explicit rights',
	EXPORT: 'Export',
	FAILED_TO_DELETE_USER: 'Failed to delete user',
	FAILED_TO_GENERATE_SECRET: 'Failed to generate secret',
	FIELDS: 'Fields',
	FIELD_CODE: 'Code',
	FIELD_COMMENT: 'Comment',
	FIELD_CONNECTION: 'Connection String',
	FIELD_DESCRIPTION: 'Description',
	FIELD_DIRECT_DEPLOYMENT: 'Direct deployment',
	FIELD_DOMAIN: 'Domain',
	FIELD_GIT_DEFAULT_BRANCH: 'Default Branch',
	FIELD_GIT_LOGIN_NAME: 'GIT LoginName',
	FIELD_GIT_PASSWORD_TOKEN: 'GIT Password Token',
	FIELD_GIT_PRIVATE_KEY: 'Private Key',
	FIELD_GIT_PUBLIC_KEY: 'Public Key',
	FIELD_GIT_URL: 'Git URL',
	FIELD_ID: 'Id',
	FIELD_IS_NOT_MATCHED: 'Field is not matched',
	FIELD_NAME: 'Name',
	FIELD_PRODUCTION: 'Production',
	FIELD_REMEMBER_PASSWORD: 'Remember password',
	FIELD_SCRIPT: 'Script',
	FIELD_USERNAME: 'Username',
	FIELD_VALUE: 'Value',
	FILE_EXTENSION: 'File extension',
	FILTER: 'Filter',
	FILTER_ALL_PLACEHOLDER: 'All',
	FILTER_BUTTON: 'Filter',
	FILTER_NO_RESULT_TEXT: 'No results',
	FINISH_NODE: 'Finish node',
	FINISH_SCRIPT: 'Run script',
	FINISH: 'Finish',
	FIX_IMPACTS: 'Fix impacts',
	FOLDER: 'Folder',
	FOLDER_PREVIEW_APIS: 'APIs',
	FOLDER_PREVIEW_EMPTY_DESC:
		'Click the button below to start generating the template input (RAW JSON) for this folder. Large folders may take longer and produce a large payload.',
	FOLDER_PREVIEW_EMPTY_TITLE: 'No preview generated yet',
	FOLDER_PREVIEW_GENERATE: 'Generate preview',
	FOLDER_PREVIEW_LINKED_TABLES: 'Linked tables',
	FOLDER_PREVIEW_NO_FOLDER_OBJECT_TYPE:
		'Preview could not start because no folder object type is configured for this company.',
	FOLDER_PREVIEW_MAPPINGS: 'Mappings',
	FOLDER_PREVIEW_OPTIONS_DESC:
		'Choose which folder object type to use for template generation. Your choice is saved for this browser.',
	FOLDER_PREVIEW_OPTIONS_TITLE: 'Preview options',
	FOLDER_PREVIEW_PROGRESS_DESC:
		'Generating RAW JSON for the folder and all child elements. This runs as one background task.',
	FOLDER_PREVIEW_PROGRESS_TITLE: 'Generating preview',
	FOLDER_PREVIEW_REGENERATE: 'Regenerate',
	FOLDER_PREVIEW_STALE_WARNING:
		'This preview may be outdated. Snapshot from {0}. Regenerate to reflect the latest folder changes.',
	FOLDER_PREVIEW_SOURCE_TABLES: 'Source tables',
	FOLDER_PREVIEW_START: 'Start preview',
	FOLDER_PREVIEW_SUBFOLDERS: 'Subfolders',
	FOLDER_PREVIEW_TABLES: 'Tables',
	FOLDER_PREVIEW_VIEWS: 'Views',
	FOLDER_WORKFLOW: 'Folder workflow',
	FOLDER_ODCS_SECTION: 'Data contract (ODCS)',
	ODCS_LIMITATIONS: 'Limitations',
	ODCS_PURPOSE: 'Purpose',
	ODCS_STATUS: 'Contract status',
	ODCS_STATUS_DRAFT: 'Draft',
	ODCS_STATUS_PUBLISHED: 'Published',
	ODCS_STATUS_RETIRED: 'Retired',
	ODCS_STATUS_REVIEW: 'Review',
	ODCS_STATUS_UNDER: 'Under review',
	ODCS_TENANT: 'Tenant',
	ODCS_TENANT_INHERIT_HINT:
		'Leave empty to inherit tenant from the nearest parent folder.',
	ODCS_TENANT_INHERITED: 'Effective tenant: {0} (inherited from {1})',
	ODCS_USAGE: 'Usage',
	FRIDAY: 'Friday',
	FROM: 'From',
	FUNCTIONAL_NODES: 'Functional',
	FULLSCREEN_F11: 'Fullscreen (F11)',
	TOGGLE_FULLSCREEN: 'Toggle fullscreen',
	GENERATED_SQL_MODAL_TITLE: 'Generated SQL',
	GENERATE_CODE_FROM_NAME: 'Generate code from name',
	GENERATE_ELEMENT_CODE: 'Generate element code',
	GENERATE_SQL: 'Generate SQL',
	GENERATE_TABLE_COLUMN_CODE: 'Generate table column code',
	GENERATE_SECRET: 'Regenerate secret',
	GIT_BRANCH_NOT_FOUND_IN_REPOSITORY: 'Branch not found in repository',
	GIT_CREDENTIALS_REQUIRED_FOR_BRANCH_SELECTION:
		'Git URL and credentials are required for branch selection',
	GRAPH_EDITOR_ISSUE_NO_FINISH_NODE: 'No finish node',
	GRAPH_EDITOR_ISSUE_NO_INIT_NODE: 'No init node',
	GRAPH_EDITOR_UNABLE_FIND_TARGET: 'Unable to find target/source port',
	GROUP_ADD_USERS: 'Add users',
	GROUP_ADD_USERS_SEARCH: 'Search by name or login',
	GROUP_CLEAR_SELECTION: 'Clear selection',
	GROUP_CREATE: 'Create group',
	GROUP_CREATED_SUCCESS: 'Group created.',
	GROUP_DESCRIPTION: 'Description',
	GROUP_EMPTY_STATE:
		'No groups yet. Create one to manage roles and members together.',
	GROUP_MEMBERS: 'Members',
	GROUP_MEMBERS_ADDED: 'Members added to group.',
	GROUP_MEMBERS_COUNT_TOOLTIP: '{0} members in this group',
	GROUP_MEMBER_REMOVED: 'Member removed from group.',
	GROUP_NAME: 'Name',
	GROUP_NO_MEMBERS: 'No members in this group.',
	GROUP_NO_MEMBERS_EMPTY:
		'No members yet. Add users to grant them this group’s roles.',
	GROUP_NO_USERS_TO_ADD: 'No users available to add.',
	GROUP_REMOVE_MEMBER_CONFIRM: 'Remove {0} from this group?',
	GROUP_REMOVE_SELECTED: 'Remove selected',
	GROUP_REMOVE_SELECTED_CONFIRM: 'Remove {0} members from this group?',
	GROUP_ROLES: 'Roles',
	GROUP_ROLES_DISCARD_CONFIRM: 'You have unsaved changes. Discard?',
	GROUP_ROLES_SAVED: 'Roles updated.',
	GROUP_SELECTED_COUNT: '{0} selected',
	GROUP_SELECT_TO_VIEW: 'Select a group to view and edit roles and members.',
	GROUP_SELECT_USERS_TO_ADD: 'Select users to add to the group.',
	GROUPS: 'Groups',
	HAS_HEADERS: 'Has headers',
	HIDE_TREE: 'Hide tree',
	HH: 'HH',
	HISTORICAL: 'Historical',
	HISTORICAL_TABLE: 'Historical table',
	HISTORY_TABLE: 'History table',
	IGNORE: 'Ignore',
	IGNORE_ERRORS: 'Ignore errors',
	IMPACTED_COLUMNS: 'Impacted columns',
	IMPACTED_TABLES: 'Impacted tables',
	IMPACTED_TABLES_AND_COLUMNS: 'Impacted tables and columns',
	IMPACTS: 'Impacts',
	IDENTIFICATION: 'Identification',
	IMPORT: 'Import',
	IMPORT_BUTTON: 'Import',
	IMPORT_CASE_SENSITIVE: 'Case sensitive',
	IMPORT_COLUMNS: 'Import columns',
	IMPORT_COLUMN_COMMENT: 'Column comment',
	IMPORT_COLUMN_NAME: 'Column name',
	IMPORT_COLUMN_TYPE: 'Column data type',
	IMPORT_CREATE_NEW_DOMAINS: 'Create new domains',
	IMPORT_CSV_COLUMNS_ERROR:
		'At least 2 columns (Column name, Data type) are required. {0} columns found.',
	IMPORT_CSV_FORMAT_ERROR:
		"File doesn't seem to be CSV. Only CSV files can be imported.",
	IMPORT_CSV_INFO:
		'CSV file, first row is header, with {0} separator and 3 columns:',
	IMPORT_ERROR_DESCRIPTION: 'Please, upload file with valid format.',
	IMPORT_ERROR_TITLE: 'Wrong file format',
	IMPORT_FAILED: 'Import failed',
	IMPORT_FAILED_UKNOWN_ERROR: 'Failed to import the file.',
	IMPORT_CHECK_FAILED: 'Check failed',
	IMPORT_GENERATE_CODES: 'Generate Codes',
	IMPORT_MORE_TEXT: 'And {0} more...',
	IMPORT_NAMES_NORMALISATION: 'Names normalisation',
	IMPORT_NAMES_NORMALISATION_NONE: 'None',
	IMPORT_NAMES_NORMALISATION_UPPERCASE_ALL: 'Uppercase all',
	IMPORT_NAMES_NORMALISATION_UPPERCASE_FIRST_CHAR:
		'Uppercase the first characters',
	IMPORT_SQL: 'Import SQL',
	IMPORT_SQL_DIALOG_TITLE: 'Import SQL File',
	IMPORT_SQL_UPLOADING: 'Importing SQL file...',
	IMPORT_SQL_SUCCESS: 'SQL import completed successfully',
	IMPORT_SQL_ERROR: 'SQL import failed',
	IMPORT_SQL_STOP_WARNING:
		'Are you sure you want to stop the import? The process may continue on the server.',
	IMPORT_SQL_SELECT_FILE: 'Select or drop SQL file',
	IMPORT_SQL_CURRENT_STEP: 'Current step',
	IMPORT_SQL_COMPLETED_STEPS: 'Completed steps',
	IMPORT_SQL_TAB_UPLOAD: 'Upload File',
	IMPORT_SQL_TAB_PASTE: 'Paste SQL',
	IMPORT_SQL_PASTE_PLACEHOLDER: 'Paste your SQL code here...',
	IMPORT_SQL_TEXT_EMPTY: 'Please enter SQL code or select a file',
	IMPORT_STRUCTURE: 'Import structure',
	IMPORT_STRUCTURE_READY: 'Ready to import. Click Import to continue.',
	IMPORT_STRUCTURE_READY_WITH_WARNINGS:
		'Ready to import with warnings. Review them below, then click Import.',
	IMPORT_SYSTEM: 'Import system',
	TRY_AGAIN: 'Try Again',
	INCOMPATIBLE_TARGET: 'Incompatible target',
	INCONSISTENT_DOMAINS: 'Inconsistent domains',
	INCONSISTENT_TABLES: 'Inconsistent tables',
	CUSTOM_ATTRIBUTE_NOT_FOUND: 'Custom attribute not found',
	OBJECT_SETTING_NOT_FOUND: 'Object type not found',
	OWNER_NOT_FOUND: 'Owner not found',
	BUSINESS_DOMAIN_NOT_FOUND: 'Business domain not found',
	RESPONSIBLE_ANALYST_NOT_FOUND: 'Responsible analyst not found',
	RESPONSIBLE_PERSON_NOT_FOUND: 'Responsible person not found',
	TABLE_ALREADY_EXISTS: 'Table already exists',
	TECHNICAL_COLUMN_COLLISION: 'Technical column collision',
	SYSTEM_USER_NOT_FOUND: 'System user not found',
	IMPORT_EXISTING_ELEMENTS_MODE: 'Existing elements',
	IMPORT_EXISTING_ELEMENTS_OVERWRITE: 'Overwrite',
	IMPORT_EXISTING_ELEMENTS_MERGE: 'Merge',
	IMPORT_CREATE_STEREOTYPES: 'Create missing stereotypes',
	IMPORT_IGNORE_MISSING_BO: 'Ignore missing business properties',
	IMPORT_IGNORE_MISSING_OBJECT_TYPES: 'Ignore missing object types',
	IMPORT_IGNORE_TECHNICAL_COLUMN_COLLISION: 'Ignore technical column collision',
	IMPORT_FK_MISSING_TABLE: 'FK missing table',
	IMPORT_FK_MORE_TABLES: 'FK more tables',
	IMPORT_FK_IGNORE: 'Ignore',
	IMPORT_FK_IMPORT: 'Import',
	IMPORT_FK_IMPORT_EXISTING: 'Import existing',
	IMPORT_FK_IMPORT_IMPORTED: 'Import imported',
	IMPORT_IGNORE_DOMAIN_DUPLICITIES: 'Ignore domain duplicities',
	IMPORT_IGNORE_INCONSISTENT_DOMAIN: 'Ignore inconsistent domains',
	INDEXES_NO_COLUMNS_INFO:
		'You will be able to create indexes as soon as you define at least one table column.',
	INDEX_EDIT_MODAL_TITLE: 'Edit index {0}',
	INDEX_NAME: 'Index name',
	INHERITED_RIGHTS: 'Inherited rights',
	INIT_CRON: 'Cron string',
	INIT_DAY: 'Day',
	INIT_INTERVAL: 'Interval',
	INIT_INTERVAL_DAILY: 'Daily',
	INIT_INTERVAL_MONTHLY: 'Monthly',
	INIT_INTERVAL_WEEKLY: 'Weekly',
	INIT_NODE: 'Init node',
	INIT_OTHER_WORKFLOW: 'Other workflow',
	INIT_SCRIPT: 'Script',
	INIT_TIME: 'Time',
	INIT_TYPE: 'Start type',
	INIT_TYPE_CRON: 'Cron string',
	INIT_TYPE_INTERVAL: 'Interval',
	INIT_TYPE_SCRIPT: 'Run script',
	INIT_TYPE_WORKFLOW_FINISH: 'Other workflow finish',
	INIT_WEEKDAY: 'Weekday',
	INPUT_PARAMETER: 'Input parameter',
	Info: 'INFO',
	INPUT_TYPE: 'Input type',
	INSERT_ROW_BELOW: 'Insert row below',
	INSERT_ROW_HERE: 'Insert row here',
	ISSUES_TITLE: 'Issues',
	KEYS_NO_COLUMNS_INFO:
		'You will be able to create keys as soon as you define at least one table column.',
	KEYBOARD_SHORTCUTS: 'Keyboard shortcuts',
	SHORTCUTS_SECTION_GENERAL: 'General',
	SHORTCUTS_SECTION_TABLE_NAVIGATION: 'Table Navigation',
	SHORTCUTS_SECTION_TABLE_EDITING: 'Table Editing',
	SHORTCUTS_SECTION_FOCUS_NAVIGATION: 'Focus Navigation',
	SHORTCUTS_SAVE_CHANGES: 'Save changes',
	SHORTCUTS_SWITCH_TABS: 'Switch tabs',
	SHORTCUTS_FULLSCREEN_EDITOR: 'Fullscreen editor',
	SHORTCUTS_CANCEL_CLOSE: 'Cancel / Close',
	SHORTCUTS_NAVIGATE_CELLS: 'Navigate cells',
	SHORTCUTS_JUMP_FIRST_LAST_ROW: 'Jump to first/last row',
	SHORTCUTS_EDIT_CELL: 'Edit cell',
	SHORTCUTS_NEXT_CELL: 'Next cell',
	SHORTCUTS_INSERT_ROW_BELOW: 'Insert row below',
	SHORTCUTS_DELETE_ROW: 'Delete row',
	SHORTCUTS_SAVE_AND_MOVE_TO_CELL: 'Save & move to cell',
	SHORTCUTS_FOCUS_TOOLBAR: 'Focus toolbar',
	SHORTCUTS_FOCUS_BREADCRUMBS: 'Focus breadcrumbs',
	SHORTCUTS_JUMP_TO_EDITORS_BELOW: 'Jump to editors below',
	SHORTCUTS_MAC_DETECTED: 'Mac detected',
	SHORTCUTS_WIN_LINUX_DETECTED: 'Windows/Linux detected',
	SHORTCUTS_PRESS_QUESTION_FOR_HELP: 'Press ? for help',
	LABEL: 'Label',
	LAST_VERSION: 'Version {0} by {1}',
	LATEST: 'Latest',
	LATEST_RELEASE: 'Latest release',
	DEPLOYMENT_PACKAGE: 'Deployment package',
	LEFT_PORT: 'left',
	LIST_OF_RELEASES: 'List of releases',
	LOCK: 'Lock',
	LOCKED_BY_USER: 'Locked by {0}',
	LOCKED_BY_YOU: 'Locked by you',
	LOCKED_BY_OTHERS: 'Locked by others',
	FORCE_UNLOCK_OTHERS: 'Include elements locked by other users (force unlock)',
	LOCK_RESOURCE: 'Lock resource',
	LOGIN: 'Login',
	LOGIN_EXPIRED_TOKEN: 'Your session has expired',
	LOGIN_HARD_LOCK:
		'Your account is banned. Contact admin to unlock your account',
	LOGIN_INVALID_CREDENTIALS: 'Invalid username or password',
	LOGIN_PASSWORD: 'Password',
	LOGIN_SOFT_LOCK: 'Your account is locked for {0}',
	LOGIN_SUBMIT: 'Login',
	LOGIN_USERNAME: 'Username',
	LOGOUT: 'Logout',
	LOADING: 'Loading...',
	LETTER_CASE_TOGGLE: 'Letter case toggle',
	MANAGE: 'Manage',
	MAKE_CURRENTLY_DISPLAYED_VERSION_THE_LATEST_ONE:
		'Make currently displayed version the latest one',
	MAPPING: 'Mapping',
	MAPPINGS_NOT_EXISTS: 'Mappings not exists',
	MAPPINGS_READ: 'Read mappings',
	MAPPING_CODE: 'Code',
	MAPPING_COLUMNS_COLUMN: 'Column',
	MAPPING_COLUMNS_COMMENT: 'Comment',
	MAPPING_COLUMNS_DESCRIPTION: 'Description',
	MAPPING_COLUMNS_GROUP_BY_FLAG: 'Group by',
	MAPPING_COLUMNS_KEY_FLAG: 'Key',
	MAPPING_COLUMNS_MAPPING: 'Mapping',
	MAPPING_COLUMNS_OUTER_MAPPING: 'Outer mapping',
	MAPPING_COLUMNS_UPDATE_FLAG: 'Update',
	MAPPING_COMMENT: 'Comment',
	MAPPING_CONDITION: 'Mapping Run Condition',
	MAPPING_CONTEXT_SCRIPT: 'Mapping context script',
	MAPPING_CRITERIA: 'Criteria',
	MAPPING_DEFAULT: 'Mapping default',
	MAPPING_DELETE_CONTEXT_SCRIPT: 'Mapping delete context script',
	MAPPING_DESCRIPTION: 'Description',
	MAPPING_DISTINCT: 'Distinct',
	MAPPING_FIELD_DESCRIPTION: '{0} description',
	MAPPING_NAME: 'Name',
	MAPPING_OUT_WHERE: 'Out where',
	MAPPING_POST_MAPPING_SCRIPT: 'Post-mapping script',
	MAPPING_PRE_MAPPING_SCRIPT: 'Pre-mapping script',
	MAPPING_READ: 'Read mapping',
	MAPPING_ROWSET: 'Rowset',
	MAPPING_SOURCES: 'Sources',
	MAPPING_SOURCES_ALIAS: 'Alias',
	MAPPING_SOURCES_EXPRESSION: 'Expression',
	MAPPING_SOURCES_OBJECT: 'Source Object',
	MAPPING_SOURCES_OBJECT_TYPE: 'Object Type',
	MAPPING_SOURCES_OBJECT_TYPE_DUMMY: 'Dummy',
	MAPPING_SOURCES_OBJECT_TYPE_SUB_SELECT: 'Sub Select',
	MAPPING_SOURCES_OBJECT_TYPE_TABLE: 'Table',
	MAPPING_SOURCES_OBJECT_TYPE_VIEW: 'View',
	MAPPING_SOURCES_SOURCE_CONTEXT: 'Source Context',
	MAPPING_SOURCES_STEREOTYPE: 'Stereotype',
	MAPPING_SOURCES_STEREOTYPE_FROM: 'FROM',
	MAPPING_SOURCES_STEREOTYPE_FULL_OUTER_JOIN: 'FULL OUTER JOIN',
	MAPPING_SOURCES_STEREOTYPE_JOIN: 'JOIN',
	MAPPING_SOURCES_STEREOTYPE_LEFT_JOIN: 'LEFT JOIN',
	MAPPING_SOURCES_STEREOTYPE_LEFT_OUTER_JOIN: 'LEFT OUTER JOIN',
	MAPPING_SOURCES_STEREOTYPE_RIGHT_JOIN: 'RIGHT JOIN',
	MAPPING_SOURCES_STEREOTYPE_RIGHT_OUTER_JOIN: 'RIGHT OUTER JOIN',
	MAPPING_SOURCES_STEREOTYPE_CROSS_JOIN: 'CROSS JOIN',
	MAPPING_SOURCES_STEREOTYPE_UNION: 'UNION',
	MAPPING_SOURCES_STEREOTYPE_UNION_ALL: 'UNION ALL',
	MAPPING_SOURCE_HINTS: 'Source hints',
	MAPPING_STATUS: 'Status',
	MAPPING_STATUS_FROZEN: 'Frozen',
	MAPPING_STATUS_LOGICAL_COMPLETED: 'Logical completed',
	MAPPING_STATUS_LOGICAL_IN_PROGRESS: 'Logical in progress',
	MAPPING_STATUS_PHYSICAL_COMPLETED: 'Physical completed',
	MAPPING_STATUS_PHYSICAL_IN_PROGRESS: 'Physical in progress',
	MAPPING_STEREOTYPE: 'Stereotype',
	MAPPING_TARGET_CRITERIA: 'Target criteria',
	MAPPING_TARGET_HINTS: 'Target hints',
	MAPPING_TRUNCATE: 'Truncate',
	MAPPING_TYPE: 'Mapping type',
	MAPPING_WRITE: 'Write mapping',
	MARKDOWN_SUPPORTED: 'Markdown supported',
	MARK_AS_DEPLOYED: 'Mark as deployed',
	MASS_DOWNLOAD: 'Generate script',
	MASS_DOWNLOAD_BUTTON: 'Generate',
	MASS_DOWNLOAD_STATUS: 'Status',
	MASS_DOWNLOAD_SORTING: 'Sorting',
	MASS_DOWNLOAD_SORTING_DEFAULT: 'Default sorting',
	MASS_DOWNLOAD_STRATEGY: 'Settings',
	MASS_EXPORT_AFFECTED_MESSAGE:
		'Would you like to continue? This would affect totally {0} elements.',
	MASTER_NODE_CODE: 'Master node code',
	MASTER_NODE_NAME: 'Master node name',
	MASTER_NODE_NAME_ACRONYM: 'Master node name acronym',
	MAXIMIZE: 'Maximize',
	MINIMIZE: 'Minimize',
	MERMAID_DIAGRAM: 'Mermaid Diagram',
	MERMAID_RENDER_ERROR: 'mermaid (render error)',
	MERMAID_RENDER_FAILED: 'Failed to render diagram',
	MERMAID_STREAMING: 'mermaid (streaming...)',
	MESSAGE: 'Message',
	OBJECT: 'Object',
	DETAIL: 'Detail',
	MM: 'MM',
	MONDAY: 'Monday',
	MONTHS: 'Months',
	MORE_ACTIONS: 'More actions',
	MISSING_CLIENT_ID: 'Missing client ID',
	NAME: 'Name',
	NAME_REQUIRED: 'Name is required',
	NAME_CANNOT_CONTAIN_DOT: 'Name cannot have dot / period',
	NAME_NOT_SET: 'Name not set',
	NAMING: 'Naming',
	NAMING_API_COLLECTION_CODE: 'Rowset code',
	NAMING_API_NODE_CODE: 'API node code',
	NAMING_CURRENT_NODE_CODE: 'Current Node Code',
	NAMING_CURRENT_NODE_NAME: 'Current Node Name',
	NAMING_CURRENT_NODE_STEREOTYPE_CODE: 'Current Node Stereotype Code',
	NAMING_CURRENT_NODE_STEREOTYPE_NAME: 'Current Node Stereotype Name',
	NAMING_CURRENT_NODE_TYPE: 'Current node type',
	NAMING_CURRENT_NODE_TYPE_ABBR: 'Current node type abbr',
	NAMING_DATEYYYYMMDD: 'Date YYYYMMDD',
	NAMING_DDL_SCRIPT_NAME: 'DDL script name',
	NAMING_DEFAULT_MAPPING_CODE: 'Default mapping code',
	NAMING_DEFAULT_MAPPING_NAME: 'Default mapping name',
	NAMING_EXPORT_NAME: 'Export name',
	NAMING_HISTORICAL_DEFAULT_MAPPING_CODE: 'Historical default mapping code',
	NAMING_HISTORICAL_DEFAULT_MAPPING_NAME: 'Historical default mapping name',
	NAMING_HISTORICAL_TABLE_CODE: 'Historical table code',
	NAMING_HISTORICAL_TABLE_NAME: 'Historical table name',
	NAMING_INTERFACE_DEFAULT_MAPPING_CODE: 'Interface default mapping code',
	NAMING_INTERFACE_DEFAULT_MAPPING_NAME: 'Interface default mapping name',
	NAMING_MAPPING_CODE: 'Mapping code',
	NAMING_OWNER_NAME: 'Owner name',
	NAMING_PARENT_NODE_CODE: 'Parent Node Code',
	NAMING_PARENT_NODE_NAME: 'Parent Node Name',
	NAMING_PARENT_SYSTEM_CODE: 'Parent System Code',
	NAMING_PARENT_SYSTEM_NAME: 'Parent System Name',
	NAMING_PREVIEW_DDL_CURRENT_NODE_CODE: 'CRNT_NODE',
	NAMING_PREVIEW_DDL_CURRENT_NODE_NAME: 'Current Node',
	NAMING_PREVIEW_DDL_CURRENT_NODE_STEREOTYPE_CODE: 'CRNT_NODE_STEREOTYPE',
	NAMING_PREVIEW_DDL_CURRENT_NODE_STEREOTYPE_NAME: 'Current Node Stereotype',
	NAMING_PREVIEW_DDL_CURRENT_NODE_TYPE: 'TABLE',
	NAMING_PREVIEW_DDL_CURRENT_NODE_TYPE_ABBR: 'T',
	NAMING_PREVIEW_DDL_DATEYYYYMMDD: '20100423',
	NAMING_PREVIEW_DDL_MAPPING_CURRENT_NODE_TYPE: 'MAPPING',
	NAMING_PREVIEW_DDL_MAPPING_CURRENT_NODE_TYPE_ABBR: 'MAP',
	NAMING_PREVIEW_DDL_OBJECT_CODE: 'MAPPING',
	NAMING_PREVIEW_DDL_OBJECT_NAME: 'Mapping',
	NAMING_PREVIEW_DDL_OWNER_NAME: 'Owner',
	NAMING_PREVIEW_DDL_PARENT_NODE_CODE: 'PRNT_NODE',
	NAMING_PREVIEW_DDL_PARENT_NODE_NAME: 'Parent Node',
	NAMING_PREVIEW_DDL_PARENT_SYSTEM_CODE: 'PRNT_SYS',
	NAMING_PREVIEW_DDL_PARENT_SYSTEM_NAME: 'Parent System',
	NAMING_PREVIEW_PRIMARY_KEY_TABLE_CODE: 'TBL_CODE',
	NAMING_PREVIEW_PRIMARY_KEY_TABLE_NAME: 'Table name',
	NAMING_PREVIEW_PRIMARY_KEY_TABLE_STEREOTYPE_CODE: 'STEREOTYPE',
	NAMING_PRIMARY_KEY_TABLE_CODE: 'Table code',
	NAMING_PRIMARY_KEY_TABLE_STEREOTYPE_CODE: 'Table stereotype',
	NAMING_QUEUE_CODE: 'Queue code',
	NAMING_REFERENCE_TABLE_CODE: 'Reference table code',
	NAMING_REFERENCE_TABLE_NAME: 'Reference table name',
	NAMING_SEQUENCE_NAME: 'Sequence name',
	NAMING_TABLE_CODE: 'Table code',
	NAMING_TAB_ELEMENT_TYPES: 'Element types',
	NAMING_TAB_GENERATED_ELEMENTS: 'Generated elements',
	NAMING_VIEW_CODE: 'View code',
	NAVBAR_GO_TO_PLACEHOLDER: 'Go to...',
	NAVBAR_MENU_PROJECT_VIEW: 'Project view',
	NAVBAR_MENU_SETTINGS: 'Settings',
	NAVBAR_PRESENT: 'Present',
	NAVBAR_SHARE: 'Share',
	NAVBAR_TAB_DATA_CATALOG: 'Data Catalog',
	NAVBAR_TAB_DEVELOPER: 'Developer',
	NAVBAR_TAB_ONTOLOGY: 'Ontology',
	NAVBAR_TAB_REPORTS: 'Reports',
	NAVBAR_SEARCH_FILTER: 'Filter',
	NAVBAR_SEARCH_FILTER_ALL: 'All',
	NAVBAR_SEARCH_FILTER_ROOT_SYSTEM: 'System',
	NAVBAR_SEARCH_FILTER_FOLDERS: 'Folder',
	NAVBAR_SEARCH_FILTER_TABLES: 'Table',
	NAVBAR_SEARCH_FILTER_MAPPINGS: 'Mapping',
	NAVBAR_SEARCH_FILTER_MAPPING_READ: 'Read mapping',
	NAVBAR_SEARCH_FILTER_MAPPING_WRITE: 'Write mapping',
	NAVBAR_SEARCH_FILTER_VIEWS: 'View',
	NAVBAR_SEARCH_FILTER_WORKFLOWS: 'Workflow',
	NAVBAR_SEARCH_FILTER_DIAGRAMS: 'Diagram',
	NAVBAR_SEARCH_FILTER_API: 'API Node',
	NAVBAR_SEARCH_FILTER_LABEL: 'Filter search by type',
	NAVBAR_SEARCH_FILTER_SHOW_MORE: 'Show more',
	NAVBAR_SEARCH_FILTER_SHOW_LESS: 'Show less',
	NAVBAR_SEARCH_LOADING_MORE: 'Loading…',
	NAVBAR_SEARCH_LOAD_MORE: 'Load more results',
	NOT_AVAILABLE_SHORT: 'N/A',
	NETWORK_ERROR: 'Network error',
	NETWORK_ERROR_MESSAGE: 'Error occured when loading data: {0}',
	NEW_PASSWORD: 'New password',
	NEW_PASSWORD_REPEAT: 'Confirm your password',
	NEW_USER: 'Create new user',
	NEXT: 'Next',
	NO: 'NO',
	NODE_OWNER: 'Owner',
	NOTHING_HERE: 'Nothing here',
	AVAILABLE: 'Available',
	NOT_AVAILABLE: 'Not available',
	NO_DEPLOYMENT_FOR_SELECTED_ENV: 'No deployment for selected env',
	NO_FOREIGN_KEY_SELECTED: 'No Foreign key selected',
	NO_MAPPING_SELECTED: 'No mapping selected',
	NO_OBJECTS: 'No objects added',
	NUMBER_OF_SELECTED_ELEMENTS: 'Number of selected elements',
	OBJECTS: 'Objects',
	OBJECT_SETTINGS: 'Object types',
	OBJECT_TYPE: 'Object type',
	OBJECT_TYPE_CODE: 'Object type code',
	OBJECT_TYPE_NAME: 'Object type name',
	OF: 'of',
	OK: 'OK',
	OWNER: 'Owner',
	OLD_PASSWORD: 'Old password',
	ONLY_PUSHED_ENVIRONMENTS_CAN_BE_ADDED:
		'Only pushed environments can be added',
	ON_OFF: 'On/Off',
	ORDER_OF_EXECUTION: 'Order of execution',
	ORIGINAL_TABLE: 'Original table',
	OTHERS: 'Others',
	OUTPUT_FORMAT: 'Output format',
	PARALLEL: 'Parallel',
	PARALLEL_MERGE: 'Parallel merge',
	PARALLEL_START: 'Parallel start',
	PARENT: 'Parent',
	PARENT_NODE_NAME_ACRONYM: 'Parent node name acronym',
	PARITITION_STRATEGY_KEY: 'Key',
	PARITITION_STRATEGY_KEY_AND_SNAPSHOT:
		'Key  + Snapshot Date (key is select from column list)',
	PARITITION_STRATEGY_KEY_AND_SNAPSHOT_AND_DATE_EFFECTIVE:
		'Key + Snapshot Date + Snapshot Date Effective (key is select from column list)',
	PARITITION_STRATEGY_NO_PARTITION: 'No partition',
	PARITITION_STRATEGY_SNAPSHOT_DATA: 'Snapshot Date',
	PARITITION_STRATEGY_SOURCE_AND_SNAPSHOT: 'Source System + Snapshot Date',
	PARITITION_STRATEGY_SOURCE_AND_SNAPSHOT_AND_DATE_EFFECTIVE:
		'Source System + Snapshot Date + Snapshot Date Effective',
	PARITITION_STRATEGY_SOURCE_SYSTEM: 'Source System',
	PARITITION_STRATEGY_SOURCE_SYSTEM_AND_VALID_TO: 'Source System + Valid_to',
	PASSWORD_GOOD: 'Good',
	PASSWORD_STRONG: 'Strong',
	PASSWORD_VERY_STRONG: 'Very strong',
	PASSWORD_VERY_WEAK: 'Very weak',
	PASSWORD_WEAK: 'Weak',
	PATH: 'Path',
	PERMISSIONS: 'Permissions',
	PERMISSIONS_TITLE: 'Permissions',
	PERMISSIONS_USER: 'User',
	PERMISSION_CREATE_DELETE_SYSTEM: 'Create/Delete systems',
	PERMISSION_FORCE_UNLOCK: 'Force unlock',
	PERMISSION_MANAGE_ACCESS: 'Manage access',
	PERMISSION_MANAGE_LOV: 'Manage LOVs',
	PERMISSION_MANAGE_USERS: 'Manage users',
	PERMISSION_MANAGE_TEMPLATES: 'Manage templates',
	PERMISSION_MANAGE_CREDENTIALS: 'Manage credentials',
	PERMISSION_VIEW: 'View',
	PERMISSION_EDIT: 'Edit',
	ACL_ENTRIES: 'ACL entries (direct)',
	ACL_EFFECTIVE_ENTRIES: 'Effective permissions',
	ACL_EFFECTIVE_DESCRIPTION:
		'Permissions in effect at this structure (including inherited from parent). Deny overrides allow when both apply. Use the Evaluate tab to see the exact source of each decision.',
	ACL_NO_EFFECTIVE_ENTRIES: 'No effective permissions.',
	ACL_NO_EXPLICIT_PERMISSIONS: 'No permissions set',
	ACL_OPEN_PARENT_HINT: 'To change inherited permissions, open parent:',
	ACL_PARENT_STRUCTURE: 'Parent structure',
	ACL_EVALUATE_OPEN_STRUCTURE_PERMISSIONS:
		'Open ACL management for this structure',
	ACL_ADD_PREFILL_FROM_PARENT:
		'Selecting a group will pre-fill permissions from the parent.',
	ACL_PERMISSION: 'Permission',
	ACL_PERMISSION_SETTING: 'Permission setting',
	ACL_PERMISSION_INHERIT: 'Inherit',
	ACL_PERMISSION_ALLOW: 'Allow',
	ACL_PERMISSION_DENY: 'Deny',
	ACL_PERMISSIONS_COLUMN: 'Permissions',
	ADD_ACL_ENTRY: 'Add ACL entry',
	ACL_EDIT_ENTRY: 'Edit ACL entry',
	ALLOWED_PERMISSIONS: 'Allowed permissions',
	DENIED_PERMISSIONS: 'Denied permissions',
	ACL_SELECT_GROUP: 'Select group',
	ACL_ENTRY_ADDED: 'ACL entry added.',
	ACL_ENTRY_UPDATED: 'ACL entry updated.',
	ACL_ENTRY_REMOVED: 'ACL entry removed.',
	ACL_ENTRY_DELETE_CONFIRM: 'Remove ACL entry for group "{0}"?',
	ACL_NO_ENTRIES: 'No ACL entries. Add a group to set permissions.',
	ACL_TAB_MANAGE: 'Manage ACL',
	ACL_TAB_EVALUATE: 'Evaluate',
	ACL_EVALUATE_DESCRIPTION:
		'Resolved permissions for this structure with sources (which structure and group each allow or deny came from). Leave user empty to evaluate as the signed-in user.',
	ACL_EVALUATE_USER: 'User',
	ACL_EVALUATE_USER_CURRENT: 'Current user',
	ACL_EVALUATE_GROUP_HINT: 'Optional: evaluate as if only this group applied',
	ACL_EVALUATE_GROUP_ANY: 'All groups (default)',
	ACL_EVALUATE_GRANTED: 'Granted',
	ACL_EVALUATE_ALLOWED_FROM: 'Allowed from',
	ACL_EVALUATE_DENIED_FROM: 'Denied from',
	ACL_EVALUATE_NO_SOURCES: '—',
	ACL_EVALUATE_ERROR: 'Could not load evaluation.',
	ACL_EVALUATE_UNKNOWN: '—',
	ACL_EVALUATE_NO_STRUCTURE: '(no structure)',
	ACL_EVALUATE_OPEN_MANAGE: 'Open manage ACL',
	GROUP: 'Group',
	PLAIN_TEXT: 'Plain text',
	POST_SCRIPT: 'Post-script',
	PREVIEW: 'Preview',
	PREVIEW_DLL: 'Preview',
	PREVIEW_ERROR_OBJECT_TYPE:
		'System unable to generate preview. You must select object type first.',
	PREVIEW_PAGE_DESCRIPTION:
		'This area is prepared for upcoming functionality. Content will be added later.',
	PREVIEW_PAGE_DEV_ONLY: 'Available in development only',
	PRE_SCRIPT: 'Pre-script',
	PRIMARY_KEY_NAME: 'Primary key name',
	PROCEED: 'Proceed',
	PROJECT_METADATA: 'Project metadata',
	PROJECT_VIEW: 'Project view',
	PROPERTIES: 'Properties',
	PROPERTIES_DOWN: 'Down',
	PROPERTIES_SELECT_ROW: 'Please select a row to see the properties',
	PROPERTIES_TITLE: 'Properties',
	PROPERTIES_UP: 'Up',
	PROCESSING_TASK: 'Processing task',
	PUSH: 'Push',
	PUSH_DESCRIPTION: 'Version description',
	PUSH_EXIT_EDIT_MODE: 'Exit edit mode',
	PUSH_LOCK_NODE: 'Unlock node',
	PUSH_LOCK_NODES: 'Unlock nodes',
	PUSH_MODAL_HEADER: 'Push changes',
	PUSH_TO_GIT: 'Push to git',
	PUSH_TO_GIT_SUCCESS: 'Successfully pushed to git',
	PYTHON: 'Python',
	QUEUE: 'Queue',
	RAW_JSON: 'Raw',
	REFERENCE_TABLE: 'Reference table',
	REFRESH: 'Refresh',
	REVEAL_IN_TREE: 'Reveal in tree',
	REGEX_VALIDATION: 'Regex validation',
	RELATION_STATUS_BROKEN: 'Broken',
	RELATION_STATUS_FK_COL_NOT_SET: 'Foreign column not set',
	RELATION_STATUS_OK: 'Ok',
	RELATION_STATUS_PK_COL_REMOVED: 'Primary key column removed',
	RELATION_STATUS_PK_SIDE_REMOVED: 'Primary key side removed',
	RELATION_TYPE_CUSTOM_LINK: 'Custom link',
	RELATION_TYPE_LINK: 'Link',
	RELATION_TYPE_LINK_COLUMN: 'Link to column',
	RELATION_TYPE_PK_FK_COLUMN: 'Foreign column',
	RELATION_TYPE_PK_FK_TABLE: 'Foreign table',
	RELEASED: 'Released',
	RELEASE_TIME: 'Release time',
	RELEASES: 'Deployment Packages',
	RELEASE_DATE: 'Release date',
	RELEASE_DETAIL: 'Deployment package detail',
	RELEASE_DRAG_DROP_HINT:
		'Drag & Drop elements from the tree in the left panel to the "Drop element" zone',
	RELEASE_NOT_FOUND: 'Release not found',
	REMOVE: 'Remove',
	REMOVE_ACRONYM: 'Remove acronym',
	REMOVE_BUSINESS_DOMAIN: 'Remove business domain',
	REMOVE_DESC: 'Are you sure you really want to delete "{0}"',
	REMOVE_DOMAIN: 'Remove domain',
	REMOVE_ELEMENT_FROM_DEPLOYMENT_PACKAGE:
		'Remove element from deployment package',
	REMOVE_ELEMENT_FROM_DEPLOYMENT_PACKAGE_DESCRIPTION:
		'Do you want to remove element "{0}" from deployment package?',
	REMOVE_FILE: 'Remove file',
	REMOVE_OBJECT_SETTINGS: 'Remove object types',
	REMOVE_STEREOTYPE: 'Remove stereotype',
	REMOVE_TECH_COLUMN: 'Remove technical column',
	REMOVE_USER: 'Remove user',
	REPLACE_VERSION: 'Replace version',
	RESET: 'Reset',
	RESTORE: 'Restore',
	RESET_BUTTON: 'Reset',
	RESET_DESC: 'Are you sure you really want to reset password for user "{0}"',
	RESET_PASSWORD: 'Reset password',
	RESET_VERSIONS: 'Reset versions',
	RESOURCE_NAME: 'Resource name',
	READ_API: 'Read API',
	READ_ONLY_MODE: 'Read-only mode',
	RESPONSIBLE_ANALYST: 'Responsible analyst',
	RESPONSIBLE_PERSON: 'Responsible person',
	RIGHT_PORT: 'right',
	ROOT: 'Root',
	SATURDAY: 'Saturday',
	SAVE: 'Save',
	SAVE_AND_DO_NOT_UPDATE_ELEMENTS: 'Save and do not update elements',
	SAVE_AND_UPDATE_ELEMENTS: 'Save and update elements',
	SAVE_ONLY: 'Save only',
	SAVE_AND_UPDATE: 'Save & update',
	SCRIPT: 'Script',
	SCRIPT_EDITOR: 'Script editor',
	SEARCH: 'Search',
	SEARCH_ELEMENT_TYPE: 'Search element type',
	SEARCH_EMPTY: 'Nothing found',
	SEARCH_PLACEHOLDER: 'Search...',
	SELECT: 'Select',
	SELECT_SELECTED: '✓ Selected ',
	SELECT_ALL: 'Select all',
	SELECT_ALL_NODE: 'Select all node children ',
	SELECT_ELEMENT_TYPE_FOR_EDITING: 'Select element type for editing',
	SELECT_FILE: 'Select file',
	SELECT_MAPPING: 'Select mapping...',
	SELECT_MODE: 'Select mode',
	SELECT_NODE: 'Select node',
	SELECT_DATE: 'Select date',
	SELECT_DOMAIN: 'Select domain...',
	SELECT_OWNER: 'Select owner...',
	SELECT_USER: 'Select user...',
	SEQUENCE: 'Sequence',
	SEQUENCE_COLUMN: 'Sequence column',
	SETTINGS_TAB_GENERAL: 'General',
	SETTINGS_TITLE: 'Settings',
	SETTINGS_GROUP_SECURITY: 'Security',
	SETTINGS_GROUP_CONFIGURATION: 'Configuration',
	SETTINGS_GROUP_USER_INTERFACE: 'User interface',
	METACROC_DOCUMENTATION: 'MetaCroc Documentation',
	SECRET_RESET_SUCCESSFUL: 'Secret reset successful',
	SHOW_IMPACTED_TABLES: 'Show impacted tables',
	SHOW_IMPACTED_TABLES_AND_COLUMNS: 'Show impacted tables and columns',
	SHOW_IMPACTS: 'Show impacts',
	SHOW_TREE: 'Show tree',
	SINGLE_FILE: 'Single file',
	SOME_SELECTED_ELEMENTS_ARE_LOCKED_BY_OTHER_USERS_PROCEED:
		'Some selected elements are locked by other users. Unlocking will erase their autosaved working versions. Do you want to proceed?',
	SOME_SELECTED_ELEMENTS_ARE_LOCKED_BY_OTHER_USERS_SKIP:
		'Some selected elements are locked by other users and you do not have "force unlock" permission. You will not edit these locked elements during batch editing. Do you want to proceed?',
	SOMETHING_WENT_WRONG: 'Something went wrong',
	SORT_BY_NAME_ASC: 'By Structure Name ASC',
	SORT_BY_TYPE_AND_NAME_ASC: 'By Structure Type and Name ASC',
	SOURCE_ENVIRONMENT: 'Source environment',
	SOURCE_SUBSELECT: 'Source subselect',
	SQL: 'Sql',
	STATUS: 'Status',
	STATUS_EDITING: 'Editing',
	STATUS_EDITING_UNSAVED: 'Editing (unsaved)',
	STATUS_LOCKED: 'Locked',
	STATUS_VIEW_MODE: 'View',
	STATUS_MODAL_HEADER: 'Change Status Modal - {0}',
	STATUS_MODAL_MESSAGE_1: 'You have selected a new status -',
	STATUS_MODAL_MESSAGE_2:
		"Please confirm your choice to proceed. Changing the status will update the item's progress and reflect its current state in the workflow. Ensure this change is intentional, as it may impact related processes.",
	STEP: 'Step',
	STEREOTYPE: 'Stereotype',
	STEREOTYPES: 'Stereotypes',
	STEREOTYPE_CODE: 'Stereotype code',
	STEREOTYPE_NOT_FOUND: 'Stereotype not found',
	STRUCTURED_SOURCES: 'Structured',
	STRUCTURE_SEARCH_ALL_LOCKED: 'All locked',
	STRUCTURE_SEARCH_ANY_DIRECTORY: 'Any directory',
	STRUCTURE_SEARCH_ANY_STATUS: 'Any status',
	STRUCTURE_SEARCH_CLEAR_ALL: 'Clear all',
	STRUCTURE_SEARCH_CLEAR_FILTERS: 'Clear',
	STRUCTURE_SEARCH_COMING_SOON: 'Coming soon',
	STRUCTURE_SEARCH_DIRECTORY: 'Directory',
	STRUCTURE_SEARCH_HINT: 'Type at least 2 characters to search',
	STRUCTURE_SEARCH_MY_LOCKED: 'My locked',
	STRUCTURE_SEARCH_PLACEHOLDER: 'Search elements…',
	STRUCTURE_SEARCH_QUICK_FILTERS: 'Quick filters',
	STRUCTURE_SEARCH_RESULTS: 'Results',
	STRUCTURE_SEARCH_RESULTS_COUNT: '{0} results',
	STRUCTURE_SEARCH_SAVE_FILTER: 'Save filter',
	STRUCTURE_SEARCH_SAVE_FILTER_PROMPT: 'Filter name:',
	STRUCTURE_SEARCH_SAVED_FILTERS: 'Saved filters',
	STRUCTURE_SEARCH_SORT: 'Sort results',
	STRUCTURE_SEARCH_TITLE: 'Search',
	STRUCTURE_SEARCH_TYPE_FILTER: 'Type filter',
	SUBFLOW_EXECUTE: 'Subflow execute',
	SUBWORKFLOW: 'Subworkflow',
	SUB_STEREOTYPE: 'Sub stereotype',
	SUFFIX: 'Suffix',
	SUNDAY: 'Sunday',
	SWITCH_TO_HISTORY_TABLE: 'Switch to history table',
	SWITCH_TO_ORIGINAL_TABLE: 'Switch to original table',
	SWITCH_TO_TRANSLATION_TABLE: 'Switch to Translation Table',
	SYSTEM: 'System',
	SYSTEM_SELECTION_BRANCH: 'Branch',
	SYSTEM_SELECTION_NO_SYSTEM: 'No system',
	SYSTEM_SELECTION_OBJECTS: '{0} objects',
	SYSTEM_SELECTION_OPEN_SYSTEM: 'Open system',
	SYSTEM_SELECTION_SYSTEM_MENU: 'System menu',
	SYSTEM_SELECTION_SELECT_BRANCH: 'Select branch',
	SYSTEM_SELECTION_SELECT_SYSTEM: 'Select system',
	SYSTEM_TECHNOLOGY: 'System technology',
	SYSTEM_USER: 'System user',
	TABLE: 'Table',
	Table: 'TABLE',
	Grid: 'GRID',
	Constraint: 'CONSTRAINT',
	TABLE_ALREADY_EXISTS_IN_FOLDER: 'Table already exists in folder',
	TABLE_ALREADY_EXISTS_IN_SYSTEM: 'Table already exists in system',
	TABLE_BASICS: 'Table basics',
	TABLE_CODE: 'Table code',
	TABLE_COLUMNS_CODE: 'Code',
	TABLE_COLUMNS_COMMENT: 'Comment',
	TABLE_COLUMNS_DATA_TYPE: 'Data type',
	TABLE_COLUMNS_DESCRIPTION: 'Description',
	TABLE_COLUMNS_DOMAIN: 'Domain',
	TABLE_COLUMNS_DOMAIN_PLACEHOLDER: 'Select domain...',
	TABLE_COLUMNS_EMPTY: 'There are no columns',
	TABLE_COLUMNS_FOREIGN_KEY: 'Foreign Key',
	TABLE_COLUMNS_FOREIGN_KEY_SHORT: 'FK',
	TABLE_COLUMNS_INFLAG: 'In flag',
	TABLE_COLUMNS_INFLAG_SHORT: 'IN',
	TABLE_COLUMNS_MANDATORY: 'Not null',
	TABLE_COLUMNS_MANDATORY_SHORT: 'NN',
	TABLE_COLUMNS_MOVE: 'Move',
	TABLE_COLUMNS_NAME: 'Name',
	TABLE_COLUMNS_ID: 'ID',
	TABLE_COLUMNS_OUTFLAG: 'Out flag',
	TABLE_COLUMNS_OUTFLAG_SHORT: 'OUT',
	TABLE_COLUMNS_PRIMARY_KEY_ORDER: 'Primary key order',
	TABLE_COLUMNS_PRIMARY_KEY_ORDER_SHORT: 'PK',
	TABLE_COLUMNS_STEREOTYPE: 'Stereotype',
	TABLE_COLUMNS_STEREOTYPE_PLACEHOLDER: 'Select stereotype...',
	TABLE_COLUMNS_VIRTUAL_COLUMN_SCRIPT: 'Script',
	TABLE_COMMENT: 'Table comment',
	TABLE_CONSTRAINTS_AVAILABLE_COLUMNS: 'Available columns',
	TABLE_CONSTRAINTS_CLEAR_FOREIGN_KEY: 'Clear',
	TABLE_CONSTRAINTS_CODE: 'Code',
	TABLE_CONSTRAINTS_COLUMNS: 'Columns',
	TABLE_CONSTRAINTS_COLUMNS_PLACEHOLDER: 'Select columns...',
	TABLE_CONSTRAINTS_COMMENT: 'Comment',
	TABLE_CONSTRAINTS_CONSTRAINT_NAME: 'Constraint type',
	TABLE_CONSTRAINTS_CONSTRAINT_NAME_PLACEHOLDER: 'Select constraint type...',
	TABLE_CONSTRAINTS_DESCRIPTION: 'Description',
	TABLE_CONSTRAINTS_EMPTY: 'There are no keys',
	TABLE_CONSTRAINTS_ENABLED: 'Enabled',
	TABLE_CONSTRAINTS_EXPRESSION: 'Expression',
	TABLE_CONSTRAINTS_FOREIGN_KEY: 'Foreign key',
	TABLE_CONSTRAINTS_NAME: 'Name',
	TABLE_CONSTRAINTS_NO_PRIMARY_KEYS:
		'Selected table does not have any primary key',
	TABLE_CONSTRAINTS_PHYSICAL_OPTIONS: 'Physical options',
	TABLE_CONSTRAINTS_PRIMARY_KEY: 'Primary key',
	TABLE_CONSTRAINTS_REFERENCE: 'Reference',
	TABLE_CONSTRAINTS_SCRIPT: 'Script',
	TABLE_CONSTRAINTS_SELECT_FOREIGN_KEY: 'Select column',
	TABLE_CONSTRAINTS_SELECT_TABLE: 'Select table',
	TABLE_DESCRIPTION: 'Table description',
	TABLE_EXTENDED: 'Table extended',
	TABLE_FORM_IS_INVALID: "There're some invalid values in the form",
	TABLE_FORM_IS_INVALID_TITLE: 'Unable to save table',
	TABLE_GENERAL_BUSINESS_DOMAIN: 'Business domain',
	TABLE_GENERAL_BUSINESS_METADATA: 'Business metadata',
	TABLE_GENERAL_AUTHOR: 'Author',
	TABLE_GENERAL_CODE: 'Code',
	TABLE_GENERAL_COMMENT: 'Comment',
	TABLE_GENERAL_DATE: 'Date',
	TABLE_GENERAL_DESCRIPTION: 'Description',
	TABLE_GENERAL_ENTITY_TYPE: 'Entity type',
	TABLE_GENERAL_HAS_HISTORY_TABLE: 'Has history table',
	TABLE_GENERAL_NAME: 'Name',
	TABLE_GENERAL_PROJECT_METADATA: 'Project metadata',
	TABLE_GENERAL_SEQUENCE: 'Sequence',
	TABLE_GENERAL_SEQUENCE_COLUMN: 'Sequence Column',
	TABLE_GENERAL_STEREOTYPE: 'Stereotype',
	TABLE_GENERAL_TABLE_RETENTION_STRATEGY: 'Retention strategy',
	TABLE_GENERAL_TABLE_STATUS: 'Status',
	TABLE_GENERAL_TECHNICAL_METADATA: 'Technical metadata',
	TABLE_GENERAL_VERSION: 'Version',
	TABLE_INDEXES_COLUMNS: 'Columns',
	TABLE_INDEXES_COLUMNS_PLACEHOLDER: 'Select columns...',
	TABLE_INDEXES_COMMENT: 'Comment',
	TABLE_INDEXES_DESCRIPTION: 'Description',
	TABLE_INDEXES_EMPTY: 'There are no indexes',
	TABLE_INDEXES_NAME: 'Name',
	TABLE_INDEXES_PHYSICAL_OPTIONS: 'Physical options',
	TABLE_INDEXES_SORT_TYPE: 'Sort type',
	TABLE_INDEXES_UNIQUE: 'Unique',
	TABLE_NAME: 'Table name',
	TABLE_OF: 'of',
	TABLE_ROWS_PER_PAGE: 'Rows per page:',
	TABLE_PARTITIONING_COLUMN: 'Partitioning column',
	TABLE_PARTITIONING_STRATEGY: 'Partitioning strategy',
	TABLE_POST_TABLE_SCRIPT: 'Post-table script',
	TABLE_PRE_TABLE_SCRIPT: 'Pre-table script',
	TABLE_RETENTION_STRATEGY_INFINITE: 'Infinite',
	TABLE_RETENTION_STRATEGY_KEEP_FULL_HISTORY: 'Keep full history',
	TABLE_RETENTION_STRATEGY_KEEP_FULL_HISTORY_AND_EOM:
		'Keep full history and EOM',
	TABLE_RETENTION_STRATEGY_KEEP_FULL_HISTORY_AND_EOM_LABEL: 'EOM for',
	TABLE_RETENTION_STRATEGY_KEEP_FULL_HISTORY_LABEL: 'Keep full history for',
	TABLE_SCRIPT: 'Script',
	TABLE_STATUS_FROZEN: 'Frozen',
	TABLE_STATUS_LOGICAL_COMPLETED: 'Logical completed',
	TABLE_STATUS_LOGICAL_IN_PROGRESS: 'Logical in progress',
	TABLE_STATUS_PHYSICAL_COMPLETED: 'Physical completed',
	TABLE_STATUS_PHYSICAL_IN_PROGRESS: 'Physical in progress',
	TABLE_STEREOTYPE_CODE: 'Table stereotype code',
	TABLE_STEREOTYPE_NOT_FOUND: 'Table stereotype not found',
	TAB_COLUMNS: 'Columns',
	TAB_COLUMN_MAPPINGS: 'Column mappings',
	TAB_CONSTANTS: 'Constants',
	TAB_CONSTRAINTS: 'Constraints',
	TAB_DEPLOYMENTS: 'Deployments',
	TAB_DIAGRAM: 'Diagram',
	TAB_DIAGRAMS: 'Diagrams',
	TAB_DIAGRAM_NEW: 'New Diagram',
	TAB_ENVIRONMENTS: 'Environments',
	TAB_GRAPH: 'Graph',
	TAB_INDEXES: 'Indexes',
	TAB_LOOKUPS: 'Lookups',
	TAB_MAPPINGS: 'Mappings',
	TAB_MAPPINGS_API_COLLECTION: 'Rowsets',
	TAB_OTHERS: 'Others',
	TAB_OVERVIEW: 'Overview',
	TAB_PHYSICAL_OPTIONS: 'Physical options',
	TAB_PREVIEW: 'Preview',
	TAB_SOURCES: 'Sources',
	TAB_STRUCTURE: 'Attributes',
	TAB_USERS: 'System users',
	TAB_VALIDATION: 'Validation',
	TAB_WORKFLOWS: 'Workflows',
	TAKE_OVER_VERSIONS: 'Take over versions',
	TARGET_TABLE: 'Target table',
	TECHNICAL_COLUMNS_TITLE: 'Technical columns',
	TECHNICAL_COLUMN_ADD_TO_TABLES:
		'Add this column to all tables with selected stereotypes.',
	TECHNICAL_COLUMN_UPDATE_AFFECTED_MESSAGE:
		'This change affects {0} tables and may take some time to complete. Please be patient as we process the updates. You will see a progressbar indicating the current status.',
	TECHNICAL_COLUMN_UPDATE_CONFIRM_TITLE: 'Update tables?',
	TECHNICAL_METADATA: 'Technical metadata',
	TECHNOLOGY: 'Technology',
	TECH_COLUMN_CODE: 'Code',
	TECH_COLUMN_COMMENT: 'Comment',
	TECH_COLUMN_DESCRIPTION: 'Description',
	TECH_COLUMN_DOMAIN: 'Domain',
	TECH_COLUMN_FOREIGN_KEY: 'Secondary key',
	TECH_COLUMN_NAME: 'Name',
	TECH_COLUMN_NOT_NULL: 'Not null',
	TECH_COLUMN_PRIMARY_KEY: 'Primary key',
	TECH_COLUMN_SCRIPT: 'Script',
	TECH_COLUMN_STEREOTYPE: 'Table Stereotype assignment',
	TECH_COLUMN_STEREOTYPE_COLUMN: 'Column stereotype',
	TEMPLATE: 'template',
	TEMPLATES: 'Templates',
	TEMPLATE_AUTHOR: 'Author',
	TEMPLATE_COMMENT: 'Comment',
	TEMPLATE_DATA: 'Script',
	TEMPLATE_DATE: 'Template date',
	TEMPLATE_DELETE: 'Delete template',
	TEMPLATE_DESCRIPTION: 'Description',
	TEMPLATE_ELEMENT: 'Element',
	TEMPLATE_NEW: 'Create template',
	TEMPLATE_NEW_SUCCESS: 'The template has been created successfully',
	TEMPLATE_NEW_FAILED: 'The template has not been created: {0}',
	TEMPLATE_UPDATE: 'Update template',
	TEMPLATE_UPDATE_SUCCESS: 'The template has been updated successfully',
	TEMPLATE_UPDATE_FAILED: 'The template has not been updated: {0}',
	TEMPLATE_UNLOCK_SUCCESS: 'The template has been unlocked successfully',
	TEMPLATE_UNLOCK_FAILED: 'The template has not been unlocked: {0}',
	TEMPLATE_VERSION: 'Version',
	TEMPLATE_VERSIONS: 'Template versions',
	TEMPLATE_DIFF_SIDE_BY_SIDE: 'Side-by-side',
	TEMPLATE_DIFF_UNIFIED: 'Unified',
	TEXT_SOURCES: 'Text',
	THROW_EVENT: 'Throw event',
	THURSDAY: 'Thursday',
	TO: 'To',
	TUESDAY: 'Tuesday',
	TYPE: 'Type',
	TASK_RUNNING_WAIT: 'Task is now running, please wait..',
	TASK_FINISHED_DESC:
		'Task has been completed successfully. You can now proceed.',
	TASK_FINISHED: 'TASK FINISHED',
	TASK_ERROR: 'Update Failed. Please try again later.',
	TASK_START_ERROR: 'An error occurred during the start of task',
	TASK_TIMEOUT_ERROR:
		'The operation is taking longer than expected. Please try again.',
	TASK_CANCELLED: 'Task was cancelled',
	TASK_EXECUTION_FAILED: 'Task execution failed',
	EXPORT_NOT_AVAILABLE:
		'The requested export for element(s) {0} is not available',
	UNAVAILABLE_ITEMS_DIALOG_DESCRIPTION:
		'The following items you previously selected have been removed and are no longer valid. Please confirm to remove them\n' +
		'\t\t\t\t\tfrom your selections.',
	UNDEFINED_INHERIT:
		'When undefined then it inherits value from parent folders & system',
	UNKNOWN: '(unknown)',
	UNKNOWN_ERROR: 'Unknown error',
	UNLOCK: 'Unlock',
	UNLOCK_HEADER: 'Unlock',
	UNLOCK_MESSAGE_LOCKED_BY_USER:
		'Unlocking will erase autosaved working version made by {0}. Do you want to proceed? ',
	UNLOCK_MESSAGE_LOCKED_BY_YOU:
		'Unlocking will erase your autosaved working version. Do you want to proceed?',
	UNLOCK_NODE: 'Unlock node',
	UNLOCK_TEMPLATE: 'Unlock template',
	UNLOCK_TEMPLATE_CONFIRM_BY_YOU:
		'Do you really want to unlock the template "{0}"? You are the current owner of the lock.',
	UNLOCK_TEMPLATE_CONFIRM_BY_USER:
		'Do you really want to unlock the template "{0}"? This template is currently locked by {1}.',
	UNLOCK_RESOURCE: 'Unlock resource',
	UNLOCK_FAILED: 'Failed to unlock elements. Please try again.',
	UNSELECT_ALL_NODE: 'Unselect all node children',
	UNSELECT_NODE: 'Unselect node',
	UNSYNCHRONIZED: 'Unsynchronized',
	UNUSED_PORT: 'Unused {0} port',
	UPDATED_AT: 'Updated at',
	UPDATED_BY: 'Updated by',
	UPDATE_ACRONYM: 'Update acronym',
	UPDATE_BUSINESS_DOMAIN: 'Update business domain',
	UPDATE_DEPENDENCY: 'Update dependency',
	UPDATE_DIAGRAM: 'Update diagram',
	UPDATE_DOMAIN: 'Update domain',
	UPDATE_IMPACTED_TABLES: 'Update impacted tables',
	UPDATE_OBJECT_SETTINGS: 'Update object types',
	UPDATE_STEREOTYPE: 'Update stereotype',
	UPDATE_TECH_COLUMN: 'Update technical column',
	UPDATE_USER: 'Update user',
	USERS: 'Users',
	API_USERS: 'Api users',
	USER: 'User',
	USER_DEPARTMENT: 'Department',
	USER_DESC: 'Description',
	USER_LOGIN_NAME: 'Login name',
	USER_NAME: 'Name',
	USER_PASSWORD: 'Password',
	USER_PERMISSIONS: 'Permissions',
	USER_PERMISSIONS_EDIT: 'Edit permissions',
	USER_STATUS_BLOCK: 'Block user',
	USER_STATUS_BLOCK_INFO: 'Are you sure you really want to block user "{0}"',
	USER_STATUS_UNBLOCK: 'Unblock user',
	USER_STATUS_UNBLOCK_INFO:
		'Are you sure you really want to unblock user "{0}"',
	USER_SURNAME: 'Surname',
	USER_UPDATED_SUCCESSFULLY: 'User updated successfully',
	USER_CREATED_SUCCESSFULLY: 'User created successfully',
	USER_ROLES_LOAD_ERROR: 'Could not load user roles.',
	USER_TYPE_ADMIN: 'Administrator',
	USER_TYPE_API: 'API',
	USER_TYPE_FIELD: 'User type',
	USER_TYPE_COLUMN: 'Type',
	USER_TYPE_READER: 'Reader',
	USER_TYPE_STANDARD: 'Standard',
	USE_SUFFIX_ONLY_4_SYSTEM: 'Use suffix only for system',
	VALIDATION_ATTRIBUTE: 'Attribute',
	VALIDATION_DESCRIPTION: 'Description',
	VALIDATION_ELEMENT: 'Element',
	VALIDATION_FULLTEXT: 'Fulltext search',
	VALIDATION_ID: 'ID',
	VALIDATION_MESSAGE: 'Message',
	VALIDATION_NODE: 'Node',
	VALIDATION_SEVERITY: 'Severity',
	VALIDATOR_COMPARE_PASSWORDS: 'Passwords do not match',
	VALIDATOR_DUPLICATE: 'Duplicate value',
	VALIDATOR_EMAIL: 'Wrong email format',
	VALIDATION_ERRORS: 'Validation errors:',
	VALIDATOR_FLOAT_ERROR: 'Input has to be decimal',
	VALIDATOR_INTEGER_ERROR: 'Input has to be integer',
	VALIDATOR_LENGTH_MAX_ERROR: 'Maximal length of input is {0}',
	VALIDATOR_LENGTH_MIN_ERROR: 'Minimal length of input is {0}',
	VALIDATOR_LENGTH_RANGE_ERROR: 'Input has to be between {0} and {1} long',
	VALIDATOR_NUMBER_MAX_ERROR: 'Number has to be at most {0}',
	VALIDATOR_NUMBER_MINMAX_ERROR: 'Number has to be between {0} and {1}',
	VALIDATOR_NUMBER_MIN_ERROR: 'Number has to be at least {0}',
	VALIDATOR_NUMBER_RANGE_ERROR:
		'Starting value has to be less or equal to ending value',
	VALIDATOR_PASSWORD_STRENGTH:
		'Password it too weak. Increase the password length, add capital letter or number or a special character.',
	VALIDATOR_REGEX: 'Regex validation failed',
	VALIDATOR_REGEXP: 'Value does not match expression {0}',
	VALIDATOR_REQUIRED: 'Field is required',
	VALUE: 'Value',
	VERSION: 'Version',
	VERSIONS: 'Versions',
	VERSIONS_RESET: 'Versions reset',
	VERSIONS_TOOK_OVER: 'Versions took over',
	VERSION_TO_COMPARE: 'Version to compare',
	VERSION_DIFF: 'Compare versions',
	VERSION_DATE: 'Version date',
	VIEW: 'View',
	VIEW_CODE: 'Code',
	VIEW_CODE_TOOLTIP: 'Unique code identifier for the view',
	VIEW_COLUMNS_CODE: 'Code',
	VIEW_COLUMNS_COMMENT: 'Comment',
	VIEW_COLUMNS_DESCRIPTION: 'Description',
	VIEW_COLUMNS_MAPPING: 'Mapping',
	VIEW_COLUMNS_NAME: 'Name',
	VIEW_COMMENT: 'Comment',
	VIEW_CRITERIA: 'Criteria script',
	VIEW_CRITERIA_SCRIPT_DESCRIPTION: 'Criteria script description',
	VIEW_DESCRIPTION: 'Description',
	VIEW_FIELD_DESCRIPTION: '{0} description',
	VIEW_SOURCE_SCRIPT_DESCRIPTION: 'Source script description',
	VIEW_HISTORY: 'View history',
	VIEW_NAME: 'Name',
	VIEW_NAME_TOOLTIP: 'Display name for the view',
	VIEW_SOURCE: 'Source script',
	VIEW_STATUS: 'Status',
	VIEW_STATUS_FROZEN: 'Frozen',
	VIEW_STATUS_LOGICAL_COMPLETED: 'Logical completed',
	VIEW_STATUS_LOGICAL_IN_PROGRESS: 'Logical in progress',
	VIEW_STATUS_PHYSICAL_COMPLETED: 'Physical completed',
	VIEW_STATUS_PHYSICAL_IN_PROGRESS: 'Physical in progress',
	WAIT_FOR_EVENT: 'Wait for event',
	WAIT_UNTIL_FINISHED: 'Wait until finished',
	WARNING: 'Warning',
	WARNING_BANNER: 'Some of your selected items are no longer available.',
	WARNING_LOCKED_ELEMENTS_BY_OTHER_USERS:
		'Warning: Locked elements by other users',
	WEDNESDAY: 'Wednesday',
	WORKFLOW: 'Workflow',
	WORKFLOW_CODE: 'Code',
	WORKFLOW_NAME: 'Name',
	WORKFLOW_TECHNOLOGY: 'Workflow technology',
	WRITE_MAPPING: 'Write mapping',
	WRITE_MAPPINGS: 'Write mappings',
	WRONG_REGEX_SYNTAX: 'Wrong regex syntax',
	WRONG_REGEX_SYNTAX_IN_SETTINGS:
		'Wrong regex syntax in settings for this custom attribute',
	WRITE_API: 'Write API',
	YEARS: 'Years',
	YES: 'YES',
	ZIP_OWNER_FOLDER_PER_OBJECT_TYPE: 'Zip owner folder per object type',
	ZIP_PER_OWNER_AND_OBJECT_TYPE: 'Zip per owner and object type',
	ZIP_PER_STRUCTURE: 'Separate files in Zip',
	ZOOM_IN: 'Zoom in',
	ZOOM_OUT: 'Zoom out',
	ZOOM_TO_FIT: 'Zoom to fit',
	false: 'No',
	inherit: 'Inherit',
	true: 'Yes',
	EXPORT_PNG: 'Export PNG',
	EXPORT_SVG: 'Export SVG',
	GX_CARD_COMMON: 'Shared options',
	GX_CARD_CONTEXT: 'Context',
	GX_CARD_EXPECTATION: 'Expectation',
	GX_CARD_OUTPUT: 'Serialized output',
	GX_COLUMN: 'Column',
	GX_COPY_JSON: 'Copy JSON to clipboard',
	GX_EDITOR_TITLE: 'Great Expectations — column check',
	GX_EXPECTATION_TYPE: 'Expectation type',
	GX_CATALOG_LOADING: 'Loading expectations…',
	GX_CATALOG_LOAD_ERROR: 'Could not load expectations from the server.',
	GX_CATALOG_EMPTY: 'No expectations available for this column type.',
	GX_EXACT_LENGTH: 'Exact string length',
	GX_GROUP_BASIC: 'Basic & technical',
	GX_GROUP_PATTERNS: 'Patterns',
	GX_GROUP_RANGE: 'Range checks',
	GX_GROUP_SETS_AND_LISTS: 'Sets & lists',
	GX_INFERRED_TYPE: 'Inferred type',
	GX_MIN_BOUND: 'Minimum',
	GX_MAX_BOUND: 'Maximum',
	GX_MIN_LENGTH: 'Min length',
	GX_MAX_LENGTH: 'Max length',
	GX_MOSTLY: 'Mostly (0–1)',
	GX_MOSTLY_HINT: 'Leave empty to omit from the serialized expectation.',
	GX_OPEN_EDITOR: 'Great Expectations check',
	GX_TILES_MODAL_TITLE: 'Column expectations',
	GX_TILES_ADD_ARIA: 'Add expectation',
	GX_TILES_ADD_LABEL: 'Add',
	GX_COUNT_ARIA: 'Great Expectations defined for this column: {0}',
	GX_SAVE_EXPECTATION: 'Save expectation',
	GX_ODCS_PERSIST_HINT:
		'Expectations are stored on this column as ODCS DQ rules (`expectation`) and persist when you save the table.',
	GX_REMOVE_EXPECTATION_ARIA: 'Remove saved expectation',
	GX_EXPECTATION_TYPE_SHORT: 'Type',
	GX_PARAMETERS: 'Parameters',
	GX_PROPORTION_HINT: 'Values between 0 and 1',
	GX_REGEX: 'Regular expression',
	GX_REGEX_NO_MATCH: 'Does not match the sample text.',
	GX_REGEX_MATCHES: 'Matches the sample text.',
	GX_REGEX_TEST_HINT: 'Enter sample text to verify the pattern.',
	GX_REGEX_TEST_SAMPLE: 'Sample text to test',
	GX_REGEX_WAITING_PATTERN:
		'Fix the pattern or enter a valid regex to run the checker.',
	GX_ROW_CONDITION: 'Row condition (SQL)',
	GX_SERIALIZED_EMPTY: 'Select an expectation to see JSON',
	GX_SERIALIZED_PREVIEW: 'Serialized expectation',
	GX_SEVERITY: 'Severity',
	GX_SEVERITY_CRITICAL: 'Critical',
	GX_SEVERITY_INFO: 'Info',
	GX_SEVERITY_WARNING: 'Warning',
	GX_STRFTIME_FORMAT: 'Strftime format',
	GX_TEXT_VALUE: 'Pattern / value',
	GX_TYPE_NAME: 'Expected type',
	GX_UNSUPPORTED_FOR_TYPE: 'Not available for this column type',
	GX_VALUE_LIST: 'Values',
	GX_VALUE_LIST_PLACEHOLDER: 'Type and press Enter',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_BE_BETWEEN: 'Values between',
	GX_TITLE_EXPECT_COLUMN_MIN_TO_BE_BETWEEN: 'Min between',
	GX_TITLE_EXPECT_COLUMN_MAX_TO_BE_BETWEEN: 'Max between',
	GX_TITLE_EXPECT_COLUMN_MEAN_TO_BE_BETWEEN: 'Mean between',
	GX_TITLE_EXPECT_COLUMN_MEDIAN_TO_BE_BETWEEN: 'Median between',
	GX_TITLE_EXPECT_COLUMN_STDEV_TO_BE_BETWEEN: 'Std dev between',
	GX_TITLE_EXPECT_COLUMN_SUM_TO_BE_BETWEEN: 'Sum between',
	GX_TITLE_EXPECT_COLUMN_UNIQUE_VALUE_COUNT_TO_BE_BETWEEN:
		'Unique count between',
	GX_TITLE_EXPECT_COLUMN_PROPORTION_OF_NON_NULL_VALUES_TO_BE_BETWEEN:
		'Non-null proportion between',
	GX_TITLE_EXPECT_COLUMN_VALUE_LENGTHS_TO_BE_BETWEEN: 'Length between',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_BE_IN_SET: 'In set',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_NOT_BE_IN_SET: 'Not in set',
	GX_TITLE_EXPECT_COLUMN_DISTINCT_VALUES_TO_EQUAL_SET: 'Distinct equals set',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_MATCH_REGEX_LIST: 'Match regex list',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_NOT_MATCH_REGEX_LIST: 'Not match regex list',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_MATCH_LIKE_PATTERN_LIST: 'Match LIKE list',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_NOT_MATCH_LIKE_PATTERN_LIST:
		'Not match LIKE list',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_BE_IN_TYPE_LIST: 'In type list',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_MATCH_REGEX: 'Match regex',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_NOT_MATCH_REGEX: 'Not match regex',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_MATCH_LIKE_PATTERN: 'Match LIKE pattern',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_NOT_MATCH_LIKE_PATTERN:
		'Not match LIKE pattern',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_MATCH_STRFTIME_FORMAT: 'Match date format',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_NOT_BE_NULL: 'Not null',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_BE_NULL: 'Is null',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_BE_UNIQUE: 'Unique',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_BE_INCREASING: 'Increasing',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_BE_DECREASING: 'Decreasing',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_BE_JSON_PARSEABLE: 'Valid JSON',
	GX_TITLE_EXPECT_COLUMN_VALUES_TO_BE_OF_TYPE: 'Of type',
	GX_TITLE_EXPECT_COLUMN_TO_EXIST: 'Column exists',
	GX_TITLE_EXPECT_COLUMN_VALUE_LENGTHS_TO_EQUAL: 'Exact length',
	GX_EXP_COLUMN_VALUES_TO_BE_BETWEEN:
		'Each non-null value must fall within the specified interval (string: length bounds → lengths expectation).',
	GX_EXP_COLUMN_MIN_TO_BE_BETWEEN:
		'The minimum value in the column must fall within the specified interval.',
	GX_EXP_COLUMN_MAX_TO_BE_BETWEEN:
		'The maximum value in the column must fall within the specified interval.',
	GX_EXP_COLUMN_MEAN_TO_BE_BETWEEN:
		'The arithmetic mean of the values must be within the specified range.',
	GX_EXP_COLUMN_MEDIAN_TO_BE_BETWEEN: 'The median must be within the interval.',
	GX_EXP_COLUMN_STDEV_TO_BE_BETWEEN:
		'The standard deviation must be within the specified range.',
	GX_EXP_COLUMN_SUM_TO_BE_BETWEEN:
		'The sum of the values must be within the specified interval.',
	GX_EXP_COLUMN_UNIQUE_VALUE_COUNT_TO_BE_BETWEEN:
		'The number of unique values must be within the interval.',
	GX_EXP_COLUMN_PROPORTION_OF_NON_NULL_VALUES_TO_BE_BETWEEN:
		'The proportion of non-null values must be in the interval (0–1).',
	GX_EXP_COLUMN_VALUE_LENGTHS_TO_BE_BETWEEN:
		'The length of strings must be within the interval of lengths.',
	GX_EXP_COLUMN_VALUES_TO_BE_IN_SET:
		'Value must belong to the allowed set (whitelist).',
	GX_EXP_COLUMN_VALUES_TO_NOT_BE_IN_SET:
		'Value must not belong to the forbidden set (blacklist).',
	GX_EXP_COLUMN_DISTINCT_VALUES_TO_EQUAL_SET:
		'The set of unique values must exactly equal the input.',
	GX_EXP_COLUMN_VALUES_TO_MATCH_REGEX_LIST:
		'Matches at least one regular expression from the list.',
	GX_EXP_COLUMN_VALUES_TO_NOT_MATCH_REGEX_LIST:
		'Does not match any regex from the list.',
	GX_EXP_COLUMN_VALUES_TO_MATCH_LIKE_PATTERN_LIST:
		'Matches at least one SQL LIKE pattern from the list.',
	GX_EXP_COLUMN_VALUES_TO_NOT_MATCH_LIKE_PATTERN_LIST:
		'Does not match the list of LIKE patterns.',
	GX_EXP_COLUMN_VALUES_TO_BE_IN_TYPE_LIST:
		'The data type belongs to the list of allowed types.',
	GX_EXP_COLUMN_VALUES_TO_MATCH_REGEX:
		'Strings must match the specified regular expression.',
	GX_EXP_COLUMN_VALUES_TO_NOT_MATCH_REGEX:
		'Strings must not match the specified regular expression.',
	GX_EXP_COLUMN_VALUES_TO_MATCH_LIKE_PATTERN:
		'Strings must comply with the SQL LIKE pattern.',
	GX_EXP_COLUMN_VALUES_TO_NOT_MATCH_LIKE_PATTERN:
		'Strings must not comply with the SQL LIKE pattern.',
	GX_EXP_COLUMN_VALUES_TO_MATCH_STRFTIME_FORMAT:
		'Matches the date format (strftime).',
	GX_EXP_COLUMN_VALUES_TO_NOT_BE_NULL: 'Values must not be NULL.',
	GX_EXP_COLUMN_VALUES_TO_BE_NULL: 'Values must be NULL.',
	GX_EXP_COLUMN_VALUES_TO_BE_UNIQUE: 'Values must be unique within the column.',
	GX_EXP_COLUMN_VALUES_TO_BE_INCREASING: 'Values must increase in row order.',
	GX_EXP_COLUMN_VALUES_TO_BE_DECREASING: 'Values must decrease in row order.',
	GX_EXP_COLUMN_VALUES_TO_BE_JSON_PARSEABLE: 'Valid JSON string.',
	GX_EXP_COLUMN_VALUES_TO_BE_OF_TYPE: 'Specific data type.',
	GX_EXP_COLUMN_TO_EXIST: 'The column must exist in the table.',
	GX_EXP_COLUMN_VALUE_LENGTHS_TO_EQUAL:
		'Each value has exactly the specified length.',
	AI_ASSISTANT: 'AI Assistant',
}
